/* eslint-disable */
export const region6Barangays = [
    {
        CITY: 'AJUY',
        BARANGAY: 'ADCADARAO',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'AGBOBOLO',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'BADIANGAN',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'BARRIDO',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'BATO BIASONG',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'BAY-ANG',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'BUCANA BUNGLAS',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'CENTRAL',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'CULASI',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'LANJAGAN',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'LUCA',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'MALAYU-AN',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'MANGOROCORO',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'NASIDMAN',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'PANTALAN NABAYE',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'PANTALAN NAVARRO',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'PEDADA',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'PINANTAN DIEL',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'PINANTAN ELIZALDE',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'PINAY ESPINOSA',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'PROGRESO',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'PUENTE BUNGLAS',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'PUNTA BURI',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'ROJAS',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'SILAGON',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'TAGUBANHAN',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'TAGUHANGIN',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'TANDUYAN',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'TIPACLA',
    },
    {
        CITY: 'AJUY',
        BARANGAY: 'TUBOGAN',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'ABANG-ABANG',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'AGSING',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'ATABAY',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'BAGSAKAN',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'BAGUINGIN-LANOT',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'BAGUMBAYAN-ILAJAS',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'BALABAGO',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'BAN-AG',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'BANCAL',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'BA-ONG',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'BINALUD',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'BUGANG',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'BUHAY',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'BULOD',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'CABACANAN PROPER',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'CABACANAN RIZAL',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'CAGAY',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'COLINE',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'COLINE-DALAG',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'CUNSAD',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'CUYAD',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'DALID',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'DAO',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'GINES',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'GINOMOY',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'INGWAN',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'LAYLAYAN',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'LICO',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'LUAN-LUAN',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'MALAMBOY-BONDOLAN',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'MALAMHAY',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'MAMBAWI',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'MANASA',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'MANDUYOG',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'PAJO',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'PIANDA-AN NORTE',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'PIANDA-AN SUR',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'PUNONG',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'QUINASPAN',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'SINAMAY',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'SULONG',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'TABAN-MANGUINING',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'TABUG',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'TARUG',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'TUGASLON',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'UBODAN',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'UGBO',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'ULAY-BUGANG',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'ULAY-HINABLAN',
    },
    {
        CITY: 'ALIMODIAN',
        BARANGAY: 'UMINGAN',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'AGBATUAN',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'BADIANG',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'BALABAG',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'BALUNOS',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'CAG-AN',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'CAMIROS',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'DANGULA-AN',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'GUIPIS',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'MANGANESE',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'MEDINA',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'MOSTRO',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'PALAYPAY',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'PANTALAN',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'SAMBAG CULOB',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'SAN JUAN CRISOSTOMO',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'SERALLO',
    },
    {
        CITY: 'ANILAO',
        BARANGAY: 'VISTA ALEGRE',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'AGUSIPAN',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'ASTORGA',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'BINGAUAN',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'BITA-OYAN',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'BOTONG',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'BUDIAWE',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'CABANGA-AN',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'CABAYOGAN',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'CALANSANAN',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'CATUBIG',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'GUINAWAHAN',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'ILONGBUKID',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'INDOROHAN',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'INILIGAN',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'LATAWAN',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'LINAYUAN',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'MAINGUIT',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'MALUBLUB',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'MANAOLAN',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'MAPILI GRANDE',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'MAPILI SANJO',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'ODIONGAN',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'POBLACION (BADIANGAN)',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'SAN JULIAN',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'SARIRI',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'SIANON',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'SINUAGAN',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'TALABA',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'TAMOCOL',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'TENECLAN',
    },
    {
        CITY: 'BADIANGAN',
        BARANGAY: 'TINA',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'ARANJUEZ',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'BACOLOD',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'BALANTI-AN',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'BATUAN',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'CABALIC',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'CAMAMBUGAN',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'GIMAMANAY',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'KINALKALAN',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'LAWIS',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'MALAPOC',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'MAMHUT NORTE',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'MAMHUT SUR',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'MAYA',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'PANI-AN',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'QUIASAN',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'SALONG',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'TINGUI-AN',
    },
    {
        CITY: 'BALASAN',
        BARANGAY: 'ZARAGOSA',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'ALACAYGAN',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'BARIGA',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'BELEN',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'BOBON',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'BULARAN',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'CARMELO',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'DE LA PAZ',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'DUGWAKAN',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'FUENTES',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'FUENTES*',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'JUANICO',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'MAGDALO',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'MANAGOPAYA',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'MERCED',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'SAN SALVADOR',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'TALOKGANGAN',
    },
    {
        CITY: 'BANATE',
        BARANGAY: 'ZONA SUR',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'ACUIT',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'AGCUYAWAN CALSADA',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'AGCUYAWAN PULO',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'BAGONGBONG',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'BARAS',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'BUNGCA',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'CABILAUAN',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'CRUZ',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'GUINTAS',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'IGBONG',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'ILAUD POBLACION',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'ILAYA POBLACION',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'JALAUD',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'LAGUBANG',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'LANAS',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'LICO-AN',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'MONPON',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'PALACIAWAN',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'SALIHID',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'SOHOTON',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'SO-OL',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'TABUCAN',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'TABUC-SUBA',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'TINORIAN',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'TIWI',
    },
    {
        CITY: 'BAROTAC-NUEVO',
        BARANGAY: 'TUBUNGAN',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'BUGNAY',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'CALIFORNIA',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'DE LA PENA',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'GENERAL LUNA',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'LA FORTUNA',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'LIPATA',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'NATIVIDAD',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'NUEVA INVENCION',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'NUEVA SEVILLA',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'PUERTO PRINCESA',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'SAN GERONIMO',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'SAN LUCAS',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'UGASAN',
    },
    {
        CITY: 'BAROTAC-VIEJO',
        BARANGAY: 'VISTA ALEGRE',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'ALAPASCO',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'ALINSOLONG',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'BANBAN',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'BATAD VIEJO',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'BINON-AN',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'BOLHOG',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'BULAK NORTE',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'BULAK SUR',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'CABAGOHAN',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'CALANGAG',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'CAW-I',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'DRANCALAN',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'EMBARCADERO',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'HAMOD',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'MALICO',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'NANGKA',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'PASAYAN',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'QUIAZAN FLORETE',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'QUIAZAN LOPEZ',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'SALONG',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'TANAO',
    },
    {
        CITY: 'BATAD',
        BARANGAY: 'TAPI-AN',
    },
    {
        CITY: 'BINGAWAN',
        BARANGAY: 'AGBA-O',
    },
    {
        CITY: 'BINGAWAN',
        BARANGAY: 'ALABIDHAN',
    },
    {
        CITY: 'BINGAWAN',
        BARANGAY: 'BULABOG',
    },
    {
        CITY: 'BINGAWAN',
        BARANGAY: 'CAIROHAN',
    },
    {
        CITY: 'BINGAWAN',
        BARANGAY: 'GUINHULACAN',
    },
    {
        CITY: 'BINGAWAN',
        BARANGAY: 'INAMYUNGAN',
    },
    {
        CITY: 'BINGAWAN',
        BARANGAY: 'MALITBOG ILAWOD',
    },
    {
        CITY: 'BINGAWAN',
        BARANGAY: 'MALITBOG ILAYA',
    },
    {
        CITY: 'BINGAWAN',
        BARANGAY: 'NGINGI-AN',
    },
    {
        CITY: 'BINGAWAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BINGAWAN',
        BARANGAY: 'QUINANGYANA',
    },
    {
        CITY: 'BINGAWAN',
        BARANGAY: 'QUINAR-UPAN',
    },
    {
        CITY: 'BINGAWAN',
        BARANGAY: 'TAPACON',
    },
    {
        CITY: 'BINGAWAN',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'AGCALAGA',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'AGLIBACAO',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'AGLONOK',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'ALIBUNAN',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'BADLAN GRANDE',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'BADLAN PEQUENO',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'BADU',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'BAJE SAN JULIAN',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'BALATICON',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'BANBAN GRANDE',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'BANBAN PEQUENO',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'BARRIO CALINOG',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'BINOLOSAN GRANDE',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'BINOLOSAN PEQUENO',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'CABAGIAO',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'CAHIGON',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'CAMALONGO',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'CANABAJAN',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'CARATAGAN',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'CARVASANA',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'DALID',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'DATAGAN',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'GAMA GRANDE',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'GAMA PEQUENO',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'GARANGAN',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'GUINBONYUGAN',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'GUISO',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'HILWAN',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'IMPALIDAN',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'JAMIN-AY',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'LAMPAYA',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'LIBOT',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'LONOY',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'MALAG-IT',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'MALAGUINABOT',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'MALAPAWE',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'MALITBOG CENTRO',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'MAMBIRANAN',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'MANARIPAY',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'MARANDIG',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'MASAROY',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'MASPASAN',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'NALBUGAN',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'OWAK',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'POBLACION CENTRO',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'POBLACION DELGADO',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'POBLACION ILAYA',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'POBLACION RIZAL ILAUD',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'SIMSIMAN',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'SUPANGA',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'TABUCAN',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'TAHING',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'TIBIAO',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'TIGBAYOG',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'TOYUNGAN',
    },
    {
        CITY: 'CALINOG',
        BARANGAY: 'ULAYAN',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'ABONG',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'ALIPATA',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'ASLUMAN',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'BANCAL',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'BARANGCALAN',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'BAROSBOS',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'BINULUANGAN',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'BITO-ON',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'BOLO',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'BUAYA',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'CABILAO GRANDE',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'CABILAO PEQUENO',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'CABUGUANA',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'DAYHAGAN',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'GABI',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'GRANADA',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'GUINTICGAN',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'ISLA DE CANA',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'LANTANGAN',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'MANLOT',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'NALUMSAN',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'PANTALAN',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'PUNTA (BOLOCAWE)',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'PUNTA BATUANAN',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'TABUGON',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'TALINGTING',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'TARONG',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'TINIGBAN',
    },
    {
        CITY: 'CARLES',
        BARANGAY: 'TUPAZ',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'ABANGAY',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'AGSALANAN',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'AGTATACAY',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'BONGLOY',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'CAGUYUMAN',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'CALICUANG',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'CAMAMBUGAN',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'DAWIS',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'GINALINAN NUEVO',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'GINALINAN VIEJO',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'GUTAO',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'ILAJAS',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'LIBO-O',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'LICU-AN',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'LINCUD',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'MATANGHARON',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'MOROBORO',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'NAMATAY',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'NAZUNI',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'POTOLAN',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'SAN MATIAS',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'SINIBA-AN',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'TABUGON',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'TAMBUNAC',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'TANGHAWAN',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'TIGUIB',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'TINOCUAN',
    },
    {
        CITY: 'DINGLE',
        BARANGAY: 'TULATULA-AN',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'AGUTAYAN',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'ANGARE',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'ANJAWAN',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'BAAC',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'BAGONGBONG',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'BALANGIGAN',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'BALINGASAG',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'BANUGAN',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'BATUAN',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'BITA',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'BUGTONGAN',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'CABUDIAN',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'CALACA-AN',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'CALANG',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'CALAWINAN',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'CAPAYCAPAY',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'CAPULING',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'CATIG',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'DILA-AN',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'FUNDACION',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'INADLAWAN',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'JAGDONG',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'JAGUIMIT',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'LACADON',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'LUAG',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'MALUSGOD',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'MARIBUYONG',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'MINANGA',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'MONPON',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'NAVALAS',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'PADER',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'POBLACION A',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'POBLACION B',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'POBLACION C',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'POBLACION D',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'PONONG GRANDE',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'PONONG PEQUENO',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'PONONG PEQUEÑO',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'PUROG',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'ROMBLON',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'SAWE',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'TAMINLA',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'TINOCUAN',
    },
    {
        CITY: 'DUENAS',
        BARANGAY: 'TIPOLO',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'AURORA-DEL PILAR (POB.)',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'BACAY',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'BALABAG',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'BALUD',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'BANTUD',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'BANTUD FABRICA',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'BARAS',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'BARASAN',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'BASA-MABINI BONIFACIO (POB.)',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'BOLILAO',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'BUENAFLOR EMBARKADERO (POB.)',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'BURGOS-REGIDOR (POB.)',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'CALAO',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'CALI',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'CANSILAYAN',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'CAPALIZ',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'CAYOS',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'COMPAYAN',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'DACUTAN',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'ERMITA',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'ILAYA 1ST',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'ILAYA 2ND',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'ILAYA 3RD',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'JARDIN',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'LACTURAN',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'LOPEZ JAENA - RIZAL (POB.)',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'MANAGUIT',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'MAQUINA',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'NANDING LOPEZ',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'PAGDUGUE',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'PALOC BIGQUE',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'PALOC SOOL',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'PATLAD',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'PD MONFORT NORTH (LUBLUB)',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'PD MONFORT SOUTH (GUINSAMPANAN)',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'PULAO',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'SAPAO',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'SULANGAN',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'TABUCAN',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'TALUSAN',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'TAMBOBO',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'TAMBOILAN',
    },
    {
        CITY: 'DUMANGAS',
        BARANGAY: 'VICTORIAS',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'BAYAS (BAYAS ISLAND)',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'BAYUYAN',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'BOTONGAN',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'BOTONGON',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'BULAQUENA',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'CALAPDAN',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'CANO-AN',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'DAAN BANUA',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'DACULAN',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'GOGO',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'JOLOG',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'LOGUINGOT (LOGUINGOT ISLAND)',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'LONOY (ROMAN MOSQUEDA)',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'LUMBIA (ANA CUENCA)',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'MALBOG',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'MANIPULON',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'PANI-AN',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'PA-ON',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'POBLACION ZONE 1',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'POBLACION ZONE II',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'POBLACION ZONE III',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'TABU-AN',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'TACBUYAN',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'TANZA',
    },
    {
        CITY: 'ESTANCIA',
        BARANGAY: 'VILLA PANI-AN',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'ANONO-O',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'BAGUMBAYAN POB. (BAGUMBAYAN-GRANADA)',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'BALANTAD-CARLOS FRUTO (POB.)',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'BARAS',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'BINANUA-AN',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'BONGOL SAN MIGUEL',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'BONGOL SAN VICENTE',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'BULAD',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'BULUANGAN',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'BURGOS-GENGOS (POB.)',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'CABASI',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'CABUBUGAN',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'CALAMPITAO',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'CAMANGAHAN',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'GENEROSA-CRISTOBAL COLON (POB.)',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'GERONA-GIMENO (POB.)',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'GIRADO-MAGSAYSAY (POB.)',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'GOTERA (POB.)',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'IGCOCOLO',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'IYASAN',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'LIBO-ON GONZALES (POB.)',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'LUBACAN',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'NAHAPAY',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'NALUNDAN',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'NANGA',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'NITO-AN LUPSAG',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'PARTICION',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'PESCADORES (POB.)',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'RIZAL-TUGUISAN (POB.)',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'SANTA ROSA-LAGUNA',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'SIPITAN-BADIANG',
    },
    {
        CITY: 'GUIMBAL',
        BARANGAY: 'TORREBLANCA-BLUMENTRITT (POB.)',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'ALAMEDA',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'AMOROGTONG',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'ANILAWAN',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'BAGACAYAN',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'BAGAY',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'BALIBAGAN',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'BARANGAY 1 POBLACION',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'BARANGAY 2 POBLACION',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'BARANGAY 3 POBLACION',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'BARANGAY 4 POBLACION',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'BARANGAY 5 POBLACION',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'BARANGAY 6 POBLACION',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'BARASAN',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'BINANUA-AN',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'BOCLOD',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'BUGA',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'BUGNAY',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'CALAMPITAO',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'CALE',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'CATIRINGAN',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'CORUCUAN',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'IGCABUGAO',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'IGPIGUS',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'IGTALONGON',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'INDALUYON',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'JOVELLAR',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'KINAGDAN',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'LAB-ON',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'LACAY DOL-DOL',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'LUMANGAN',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'LUTUNGAN',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'MANTANGON',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'MULANGAN',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'PASONG',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'PASSI',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'PINAOPAWAN',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'RIRO-AN',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'SAN AMBROSIO',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'SANTA BARBARA',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'SIGNE',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'TABIAC',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'TALAYATAY',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'TAYTAY',
    },
    {
        CITY: 'IGBARAS',
        BARANGAY: 'TIGBANABA',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'ACAO',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'AMERANG',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'AMURAO',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'ANUANG',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'AYAMAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'AYONG',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'BACAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'BALABAG',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'BALUYAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'BANGUIT',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'BULAY',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'CADOLDOLAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'CAGBAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'CALAWAGAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'CALAYO',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'DUYANDUYAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'GAUB',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'GINES INTERIOR',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'GINES PATAG',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'GUIBUANGAN TIGBAUAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'INABASAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'INACA',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'INALADAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'INGAS',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'ITO NORTE',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'ITO SUR',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'JANIPAAN CENTRAL',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'JANIPAAN ESTE',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'JANIPAAN OESTE',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'JANIPAAN OLO',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'JELICUON LUSAYA',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'JELICUON MONTINOLA',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'LAG-AN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'LEONG',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'LUTAC',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'MANGUNA',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'MARAGUIT',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'MORUBUAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'PACATIN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'PAGOTPOT',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'PAMUL-OGAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'PAMURINGAO GARRIDO',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'PAMURINGAO PROPER',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'PUNGTOD',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'PUYAS',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'SALACAY',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'SULANGA',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'TABUCAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'TACDANGAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'TALANGHAUAN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'TIGBAUAN ROAD',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'TINIO-AN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'TIRING',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'TUPOL CENTRAL',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'TUPOL ESTE',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'TUPOL OESTE',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'TUY-AN',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'ZONE I POB. (BARANGAY 1)',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'ZONE II POB. (BARANGAY 2)',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'ZONE III POB. (BARANGAY 3)',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'ZONE IV POB. (BARANGAY 4)',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'ZONE IX POB. (BARANGAY 9)',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'ZONE V POB. (BARANGAY 5)',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'ZONE VI POB. (BARANGAY 6 )',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'ZONE VII POB. (BARANGAY 7)',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'ZONE VIII POB. (BARANGAY 8)',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'ZONE X POB. (BARANGAY 10)',
    },
    {
        CITY: 'CABATUAN',
        BARANGAY: 'ZONE XI POB. (BARANGAY 11)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'ABETO MIRASOL TAFT SOUTH (QUIRINO ABETO)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'AGUINALDO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'AIRPORT (TABUCAN AIRPORT)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'ALALASAN LAPUZ',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'ARGUELLES',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'ARSENAL ADUANA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'BAKHAW',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'BALABAGO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'BALANTANG',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'BALDOZA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'BANTUD',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'BANUYAO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'BAYBAY TANZA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'BENEDICTO (JARO)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'BITO-ON',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'BOLILAO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'BONIFACIO (AREVALO)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'BONIFACIO TANZA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'BUHANG',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'BUHANG TAFT NORTH',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'BUNTATALA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'BURGOS-MABINI-PLAZA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'CAINGIN',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'CALAHUNAN',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'CALAPARAN',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'CALUBIHAN',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'CALUMPANG',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'CAMALIG',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'COCHERO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'COMPANIA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'CONCEPCION-MONTES',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'CUARTERO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'CUBAY',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'DELGADO-JALANDONI-BAGUMBAYAN',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'DEMOCRACIA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'DESAMPARADOS',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'DIVINAGRACIA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'DON ESTEBAN-LAPUZ',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'DULONAN',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'DUNGON',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'DUNGON A',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'DUNGON B',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'EAST BALUARTE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'EAST TIMAWA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'EDGANZON',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'EL 98 CASTILLA (CLAUDIO LOPEZ)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'FAJARDO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'FLORES',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'GENERAL HUGHES-MONTES',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'GLORIA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'GUSTILO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'GUZMAN-JESENA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'HABOG-HABOG SALVACION',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'HIBAO-AN NORTE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'HIBAO-AN SUR',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'HINACTACAN',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'HIPODROMO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'INDAY',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'INFANTE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'INGORE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'JALANDONI ESTATE-LAPUZ',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'JALANDONI-WILSON',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'JAVELLANA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'JEREOS',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'KAHIRUPAN',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'KASINGKASING',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'KATILINGBAN',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'LAGUDA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'LANIT',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'LAPUZ NORTE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'LAPUZ SUR',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'LEGASPI DELA RAMA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'LIBERATION',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'LIBERTAD SANTA ISABEL',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'LIBERTAD-LAPUZ',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'LOBOC-LAPUZ',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'LOPEZ JAENA (JARO)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'LOPEZ JAENA NORTE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'LOPEZ JAENA SUR',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'LUNA (JARO)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'LUNA (LA PAZ)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'M. V. HECHANOVA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'MABOLO-DELGADO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'MACARTHUR',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'MAGDALO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'MAGSAYSAY VILLAGE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'MALIPAYON-DELGADO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'MANSAYA-LAPUZ',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'MARCELO H. DEL PILAR',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'MARIA CLARA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'MARIA CRISTINA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'MOHON',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'MOLO BOULEVARD',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'MONICA BLUMENTRITT',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'MONTINOLA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'MUELLE LONEY-MONTES',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'NABITASAN',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'NAVAIS',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'NONOY',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'NORTH AVANCENA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'NORTH BALUARTE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'NORTH FUNDIDOR',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'NORTH SAN JOSE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'OBRERO-LAPUZ',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'ONATE DE LEON',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'OÑATE DE LEON',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'ORTIZ',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'OUR LADY OF FATIMA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'OUR LADY OF LOURDES',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'PALE BENEDICTO RIZAL (MANDURRIAO)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'PHHC BLOCK 17',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'PHHC BLOCK 22 NHA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'POBLACION MOLO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'PRESIDENT ROXAS',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'PROGRESO-LAPUZ',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'PUNONG-LAPUZ',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'QUINTIN SALAS',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'RAILWAY',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'RIMA-RIZAL',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'RIZAL (LA PAZ)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'RIZAL ESTANZUELA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'RIZAL IBARRA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'RIZAL PALAPALA I',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'RIZAL PALAPALA II',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'ROXAS VILLAGE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAMBAG',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAMPAGUITA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAN FELIX',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAN ISIDRO (JARO)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAN ISIDRO (LA PAZ)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAN JOSE (AREVALO)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAN JOSE (CITY PROPER)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAN JOSE (JARO)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAN PEDRO (JARO)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAN PEDRO (MOLO)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SANTA FILOMENA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SANTO NINO NORTE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SANTO NINO SUR',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SANTO NIÑO SUR',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SANTO ROSARIO-DURAN',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SEMINARIO (BURGOS JALANDONI)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SIMON LEDESMA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SINIKWAY (BANGKEROHAN LAPUZ)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SO-OC',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SOUTH BALUARTE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SOUTH FUNDIDOR',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'SOUTH SAN JOSE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'TAAL',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'TABUC SUBA (JARO)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'TABUC SUBA (LA PAZ)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'TABUCAN',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'TACAS',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'TAGBAC',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'TANZA-ESPERANZA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'TAP-OC',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'TAYTAY ZONE II',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'TICUD (LA PAZ)',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'TIMAWA TANZA I',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'TIMAWA TANZA II',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'UNGKA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'VETERANS VILLAGE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'VILLA ANITA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'WEST HABOG-HABOG',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'WEST TIMAWA',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'YULO DRIVE',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'YULO-ARROYO',
    },
    {
        CITY: 'ILOILO',
        BARANGAY: 'ZAMORA-MELLIZA',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'AGLOSONG',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'AGNAGA',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'BACJAWAN NORTE',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'BACJAWAN SUR',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'BAGONGON',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'BATITI',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'BOTLOG',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'CALAMIGAN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'DUNGON',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'IGBON',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'JAMUL-AWON',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'LO-ONG',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'MACALBANG',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'MACATUNAO',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'MALANGABANG',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'MALIOGLIOG',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'NINO',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'NIPA',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'PLANDICO',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'POLOPINA',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'TALOTU-AN',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'TAMBALIZA',
    },
    {
        CITY: 'CONCEPCION',
        BARANGAY: 'TAMIS-AC',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'AGPIPILI',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'ALCANTARA',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'ALMENANA',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'ANABO',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'BANKAL',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'CABANTOHAN',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'CAPINAHAN',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'DALIPE',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'DAPDAPAN',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'GERONGAN',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'IMBAULAN',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'LAYOGBATO',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'MARAPAL',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'MILAN',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'NAGSULANG',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'NASAPAHAN',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'OMIO',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'PACUAN',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'POBLACION NW ZONE',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'POBLACION SE ZONE',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'PONTOC',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'SAN DIEGO',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'SAN JOSE MOTO',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'SEPANTON',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'SINCUA',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'TABUNAN',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'TUGAS',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'VELASCO',
    },
    {
        CITY: 'LEMERY',
        BARANGAY: 'YAWYAWAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'ABAY',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'ABILAY',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'AGROCEL POB. (AGUINALDO-ROXAS--CELSO MAYOR)',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'AMERANG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BAGACAY EAST',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BAGACAY WEST',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BOLO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BUG-OT',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BULAY',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BUNTALAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'BURAK',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CABANGCALAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CABATAC',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CAIGON',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CANANGHAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'CANAWILI',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'DAGAMI',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'DAJA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'DALUSAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'DELCAR POB. (DELGADO-CARTAGENA)',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'INABASAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'LAYOG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'LINAB',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'LINAGAN CALSADA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'LINAGAN TACAS',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'MANDOG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'MARI POB. (MABINI-RIZAL)',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'MIAPA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'NAGBA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'NASAKA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'NASLO-BUCAO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'NASULI',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'PANALIAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'PIANDAAN EAST',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'PIANDAAN WEST',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'PISPIS',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'PUNONG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SINUBSUBAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SIWALO',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'SUBOG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'THTP POB. (TAFT-THOMPSON--HUGHES-DEL PILAR)',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TIGBAUAN',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TRANGKA',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TUBANG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TULAHONG',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TUY-AN EAST',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'TUY-AN WEST',
    },
    {
        CITY: 'MAASIN',
        BARANGAY: 'UBIAN',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'ABACA',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'ASISIG',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'BAGONAWA',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'BALIWAGAN',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'BANTAYAN',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'BATUAN',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'BRAULAN',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'CABUGAO NUEVO',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'CABUGAO VIEJO',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'CAMIRI',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'CATAN-AGAN',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'COMPO',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'CUBAY',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'DACAL',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'DUMILES',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'GARITA',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'GINES NUEVO',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'GUINTORILAN',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'IMBANG PEQUENO',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'IMBESAD-AN',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'IPROG',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'LIP-AC',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'MADARAG',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'MAPILI',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'NAYON',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'PAGA',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'PALJE',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'POBLACION ILAWOD',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'QUINOLPAN',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'RUMAGAYRAY',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'TAMBUNAC',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BGY. 1 POB. (ROXAS ST.)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BGY. 10 (POB. R.V.SANCHEZ ST. SOUTH)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BGY. 11 POB. (R.V.SANCHEZ ST. NORTH)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BGY. 12 POB. (SALES MALAGA SALIEDO)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BGY. 13 POB. (STA.RITA-SACLAUSO ST.)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BGY. 14 POB. (SAN MIGUEL NORTH)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BGY. 15 POB. (SAN MIGUEL SOUTH)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BGY. 16 POB. (SAN AGUSTIN ST.)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BGY. 2 POB. (SAVILLA STO. ROSARIO)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BGY. 3 POB. (A.S.SUAREZ ST. ZONE 1)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BGY. 4 POB. (A.S.SUAREZ EAST)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BGY. 5 POB. (SANTIAGO ST.NORTH)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BGY. 6 POB. (SANTIAGO ST.SOUTH)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BGY. 7 POB. (SAN ROQUE ST.SOUTH)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BGY. 8 POB. (MONTANO - SAN ROQUE)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BGY. 9 POB. (SALAZAR SAN JOSE)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CONSOLACION',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'IGTAMBO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SANTA TERESA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SANTO ANGEL',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'ARIPDIP',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'CALAIGANG',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'ILONGBUKID',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'POSCOLON',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'SAN DIONISIO',
    },
    {
        CITY: 'SAN-RAFAEL',
        BARANGAY: 'SAN FLORENTINO',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'AGUSIPAN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'AGUTAYAN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BALABAG',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BALIBAGAN ESTE',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BALIBAGAN OESTE',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BAN-AG',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BANTAY',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BARANGAY ZONE I (POB.)',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BARANGAY ZONE II (POB.)',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BARANGAY ZONE III (POB.)',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BARANGAY ZONE IV (POB.)',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BARANGAY ZONE V (POB.)',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BARANGAY ZONE VI (POB.)',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BARANGAY ZONE VII (POB.)',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BARASAN ESTE',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BARASAN OESTE',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BINANGKILAN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BITAOG-TAYTAY',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BOLONG ESTE',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BOLONG OESTE',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BUAYAHON',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BUYO',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'CABUGAO NORTE',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'CABUGAO SUR',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'CADAGMAYAN NORTE',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'CADAGMAYAN SUR',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'CAFE',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'CALABOA ESTE',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'CALABOA OESTE',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'CAMAMBUGAN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'CANIPAYAN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'CONAYNAY',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'DAGA',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'DALID',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'DUYANDUYAN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'GEN. MARTIN T. DELGADO',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'GUNO',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'INANGAYAN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'JIBAO-AN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'LACADON',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'LANAG',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'LUPA',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'MAGANCINA',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'MALAWOG',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'MAMBUYO',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'MANHAYANG',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'MIRAGA-GUIBUANGAN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'NASUGBAN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'OMAMBOG',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'PAL-AGON',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'PUNGSOD',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'SANGCATE',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'TAGSING',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'TALANGHAUAN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'TALONGADIAN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'TIGTIG',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'TUGAS',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'TUNGAY',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'ABANGAY',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'AGCAROPE',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'AGLOBONG',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'AGUINGAY',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'ANHAWAN',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'AQUINO NOBLEZA EAST (POB.)',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'AQUINO NOBLEZA WEST (POB.)',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'ATIMONAN',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'BALANAC',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'BARASALON',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'BONGOL',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'CABANTOG',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'CALMAY',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'CANAWILI',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'CANAWILLIAN',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'CAPT. A. TIRADOR (POB.)',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'CARANAS',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'CARAUDAN',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'CARIGANGAN',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'CONCEPCION POB. (D.G. ABORDO)',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'CRISPIN SALAZAR NORTH (POB.)',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'CRISPIN SALAZAR SOUTH (POB.)',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'CUNSAD',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'DABONG',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'DAMIRES',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'DAMO-ONG',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'DON T. LUTERO CENTER (POB.)',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'DON T. LUTERO EAST (POB.)',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'DON T. LUTERO WEST POB. (DON T. LUTERO NORTH)',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'GINES',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'GOLGOTA (POB.)',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'JIBOLO',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'KUYOT',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'LOCSIN (POB.)',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'MADONG',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'MANACABAC',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'MANGIL',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'MATAG-UB',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'MONTE-MAGAPA',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'PANGILIHAN',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'PANURAN',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'PARARINGA',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'PATONG-PATONG',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'QUIPOT',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'R. ARMADA (POB.)',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'S. M. VILLA (POB.)',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'SAN JULIAN (POB.)',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'SAN PEDRO (POB.)',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'SANTA RITA (POB.)',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'SARAWAG',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'TAMBAL',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'TAMU-AN',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'TIRINGANAN',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'TOLARUCAN',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'UBIAN',
    },
    {
        CITY: 'JANIUAY',
        BARANGAY: 'YABON',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'AGSIRAB',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'AGTUMAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'ALUGMAWA',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'BADIANGAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'BALAGIAO',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'BANBAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'BANSAG',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'BAYUCO',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'BINABA-AN ARMADA',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'BINABA-AN LABAYNO',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'BINABA-AN LIMOSO',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'BINABA-AN PORTIGO',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'BINABA-AN TIRADOR',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'BOGONGBONG',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'BONTOC',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'BURI',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'BURIRAO',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'BUWANG',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'CABATANGAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'CABUNLAWAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'CAGUISANAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'CALOY-AHAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'CANINGUAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'CAPANGYAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'CAYAN ESTE',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'CAYAN OESTE',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'COROT-ON',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'COTO',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'CUBAY',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'CUNARUM',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'DAANBANWA',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'GINES',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'HIPGOS',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'JAYUBO',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'JOROG',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'LANOT GRANDE',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'LANOT PEQUENO',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'LEGAYADA',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'LUMANAY',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'MADARAG',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'MAGBATO',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'MAITE GRANDE',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'MAITE PEQUENO',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'MALAG-IT',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'MANAULAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'MARIBONG',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'MARONG',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'MISI',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'NATIVIDAD',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'PAJO',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'PANURAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'PASIG',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'POBLACION ILAWOD',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'POBLACION ILAYA',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'POONG',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'PUGHANAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'PUNGSOD',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'QUILING',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'SAGCUP',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'SAN GREGORIO',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'SIBACUNGAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'SIBAGUAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'SIMSIMAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'SUPOC',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'TAMPUCAO',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'TRANGHAWAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'TUBUNGAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'LAMBUNAO',
        BARANGAY: 'WALANG',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'BIGKE',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'BUNTATALA',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'CAGAMUTAN NORTE',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'CAGAMUTAN SUR',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'CALABOA',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'CAMANGAY',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'CARI MAYOR',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'CARI MINOR',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'GUA-AN',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'GUIHAMAN',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'GUINOBATAN',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'GUINTAS',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'LAPAYON',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'M.V. HECHANOVA (BALAGON)',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'NABITASAN',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'NAPNUD',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LEGANES',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'AGBOY NORTE',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'AGBOY SUR',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'AGTA',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'AMBULONG',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'ANONANG',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'APIAN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'AVANZADA',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'AWIS',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'AYABANG',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'AYUBO',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'BACOLOD',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'BAJE',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'BANAGAN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'BARANGBANG',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'BARASAN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'BAYAG NORTE',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'BAYAG SUR',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'BINOLBOG',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'BIRI NORTE',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'BIRI SUR',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'BOBON',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'BUCARI',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'BUGA',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'BULAD',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'BULWANG',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'CABOLO-AN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'CABUNGA-AN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'CABUTONGAN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'CAGAY',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'CAMANDAG',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'CAMANDO',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'CANANAMAN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'CAPT. FERNANDO',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'CARARA-AN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'CAROLINA',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'CAWILIHAN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'COYUGAN NORTE',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'COYUGAN SUR',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'DOROG',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'DUSACAN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'GINES',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'GUMBOC',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'IGCADIOS',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'INGAY',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'ISIAN NORTE',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'ISIAN VICTORIA',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'JAMOG GINES',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'LAMPAYA',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'LANAG',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'LANG-OG',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'LIGTOS',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'LONOC',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'MAGCAPAY',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'MALIAO',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'MALUBLUB',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'MANAMPUNAY',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'MARIRONG',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'MINA',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'MOCOL',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'NAGBANGI',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'NALBANG',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'ODONG-ODONG',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'OLUANGAN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'OMAMBONG',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'PAGA',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'PANGINMAN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'PAOY',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'PEPE',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'SALNGAN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'SAMLAGUE',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'SIOL NORTE',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'SIOL SUR',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'TACUYONG NORTE',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'TACUYONG SUR',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'TAGSING',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'TALACUAN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'TICUAN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'TINA-AN NORTE',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'TINA-AN SUR',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'TUNGUAN',
    },
    {
        CITY: 'LEON',
        BARANGAY: 'TU-OG',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'AGDUM',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'AGUIAUAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'ALIMODIAS',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'AWANG',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BACAUAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BACOLOD',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BANBANAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BANGA',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BANGLADAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BANUYAO',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BARACLAYAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BARIRI',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BAYBAY NORTE (POB.)',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BAYBAY SUR (POB.)',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BELEN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BOLHO (POB.)',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BOLOCAUE',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BUENAVISTA NORTE',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BUENAVISTA SUR',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BUGTONG LUMANGAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'BUGTONG NAULID',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'CABALAUNAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'CABANGCALAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'CABUNOTAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'CADOLDOLAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'CAGBANG',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'CAITIB',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'CALAGTANGAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'CALAMPITAO',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'CAVITE',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'CAWAYANAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'CUBAY',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'CUBAY UBOS',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'DALIJE',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'DAMILISAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'DAWOG',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'DIDAY',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'DINGLE',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'DUROG',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'FRANTILLA',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'FUNDACION',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'GINES',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'GUIBONGAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'IGBITA',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'IGBUGO',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'IGCABIDIO',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'IGCABITO-ON',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'IGCATAMBOR',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'IGDALAQUIT',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'IGDULACA',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'IGPAJO',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'IGPANDAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'IGPURO',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'IGPURO-BARIRI',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'IGSOLIGUE',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'IGTUBA',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'ILOG-ILOG',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'INDAG-AN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'KIRAYAN NORTE',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'KIRAYAN SUR',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'KIRAYAN TACAS',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'LA CONSOLACION',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'LACADON',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'LANUTAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'LUMANGAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'MABAYAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'MADUYO',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'MALAGYAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'MAMBATAD',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'MANINILA',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'MARICOLCOL',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'MARINGYAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'MATALNGON',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'MAT-Y (POB.)',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'NACLUB',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'NAM-O NORTE',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'NAM-O SUR',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'NARAT-AN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'NAROROGAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'NAULID',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'OLANGO',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'ONGYOD',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'ONOP',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'OYA-OY',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'OYUNGAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'PALACA',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'PARO-ON',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'POTRIDO',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'PUDPUD',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'PUNGTOD MONTECLARO',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'PUNGTOD NAULID',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'SAG-ON',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'SAPA (MIAGAO)',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'SARING',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'SIBUCAO',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'TAAL',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'TABUNACAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'TACAS (POB.)',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'TAMBONG',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'TAN-AGAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'TATOY',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'TICDALAN',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'TIG-AMAGA',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'TIG-APOG-APOG',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'TIGBAGACAY',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'TIGLAWA',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'TIGMALAPAD',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'TIGMARABO',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'TO-OG',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'TUGURA-AO',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'TUMAGBOC',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'UBOS ILAWOD (POB.)',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'UBOS ILAYA (POB.)',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'VALENCIA',
    },
    {
        CITY: 'MIAGAO',
        BARANGAY: 'WAYANG',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'ABAT',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'AGMANAPHAO',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'AMIROY',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'BADIANGAN',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'BANGAC',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'CABALABAGUAN',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'CAPUL-AN',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'DALA',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'GUIBUANGAN',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'JANIPA-AN EAST',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'JANIPA-AN WEST',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'MINA EAST (POB.)',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'MINA WEST (POB.)',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'NASIRUM',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'NAUMUAN',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'SINGAY',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'TALIBONG GRANDE',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'TALIBONG PEQUENO',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'TIPOLO',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'TOLARUCAN',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'TUMAY',
    },
    {
        CITY: 'MINA',
        BARANGAY: 'YUGOT',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'BACLAYAN',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'BADIANG',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'BALABAG',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'BILIDAN',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'BITA-OG GAJA',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'BOLOLACAO',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'BUROT',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'CABILAUAN',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'CAGBAN',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'CALUMBUYAN',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'DAMIRES',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'DAWIS',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'GENERAL DELGADO',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'GUINOBATAN',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'JANIPA-AN OESTE',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'JELICUON ESTE',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'JELICUON OESTE',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'PASIL',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'NEW-LUCENA',
        BARANGAY: 'WARI-WARI',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'ABILAY NORTE',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'ABILAY SUR',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'ALEGRE',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'BATUAN ILAUD',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'BATUAN ILAYA',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'BITA NORTE',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'BITA SUR',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'BOTONG',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'BURAY',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'CABANBANAN',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'CABOLOAN NORTE',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'CABOLOAN SUR',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'CADINGLIAN',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'CAGBANG',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'CALAM-ISAN',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'GALANG',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'LAMBUYAO',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'MAMBOG',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'PAKIAD',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'POBLACION NORTH',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'POBLACION SOUTH',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'POLO MAESTRA BITA',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'SALNGAN',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'SAMBALUDAN',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'SANTA CLARA',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'TAGBAC NORTE',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'TAGBAC SUR',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'TRAPICHE',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'OTON',
        BARANGAY: 'TUROG-TUROG',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'AGDAHON',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'AGDAYAO',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'AGLALANA',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'AGTABO',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'AGTAMBO',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'ALIMONO',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'ARAC',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'AYUYAN',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'BACURANAN',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'BATU',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'BAYAN',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'BITAOGAN',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'BUYO',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'CABUNGA',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'CADILANG',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'CAIROHAN',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'DALICANAN',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'GEGACHAC',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'GEMAT-Y',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'GEMUMUA-AGAHON',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'GINES VIEJO',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'IMBANG GRANDE',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'JAGUIMITAN',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'LIBO-O',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'MAASIN',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'MAGDUNGAO',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'MALAG-IT GRANDE',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'MALAG-IT PEQUENO',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'MAMBIRANAN GRANDE',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'MAMBIRANAN PEQUENO',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'MAN-IT',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'MANTULANG',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'MULAPULA',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'NUEVA UNION',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'PAGAYPAY',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'PANGI',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'POBLACION ILAWOD',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'POBLACION ILAYA',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'PUNONG',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'QUINAGARINGAN GRANDE',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'QUINAGARINGAN PEQUENO',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'SABLOGON',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'SALNGAN',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'SARAPAN',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'TAGUBONG',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'TALONGONAN',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'PASSI',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'AGANAN',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'AMPARO',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'ANILAO',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'BALABAG',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'CABUGAO NORTE',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'CABUGAO SUR',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'JIBAO-AN',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'MALI-AO',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'PAGSANGA-AN',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'PAL-AGON',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'PANDAC',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'PUROK I (POB.)',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'PUROK II (POB.)',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'PUROK III (POB.)',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'PUROK IV (POB.)',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'TIGUM',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'UNGKA I',
    },
    {
        CITY: 'PAVIA',
        BARANGAY: 'UNGKA II',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'ABANGAY',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'AMAMAROS',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'BARASAN',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'BATUAN',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'BONGCO',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'CAHAGUICHICAN',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'CALLAN',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'CANSILAYAN',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'CASALSAGAN',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'CATO-OGAN',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'CAU-AYAN',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'CULOB',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'DAPITAN',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'DAWIS',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'DONGSOL',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'FERNANDO PARCON WARD (POB.)',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'FUNDACION',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'GUIBUANGAN',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'GUINACAS',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'IGANG',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'INTALUAN',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'IWA ILAUD',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'IWA ILAYA',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'JAMABALUD',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'JEBIOC',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'LAY-AHAN',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'LOPEZ JAENA WARD (POB.)',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'LUMBO',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'MACATOL',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'MALUSGOD',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'NABITASAN',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'NAGA',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'NANGA',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'NASLO',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'PAJO',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'PALANGUIA',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'PITOGO',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'POLOT-AN',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'PRIMITIVO LEDESMA WARD (POB.)',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'PUROG',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'RUMBANG',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'SAN JOSE WARD (POB.)',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'SINUAGAN',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'TUMCON ILAUD',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'TUMCON ILAYA',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'UBANG',
    },
    {
        CITY: 'POTOTAN',
        BARANGAY: 'ZARRAGUE',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'AGDALIRAN',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'AMAYONG',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'BATUAN',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'BONDULAN',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'BORONGON',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'CANAS',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'CAPINANG',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'CUBAY',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'CUDIONAN',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'DUGMAN',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'HACIENDA CONCHITA',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'MADANLOG',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'MANDU-AWAK',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'MOTO',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'NABOROT',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'NIPA',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'ODIONGAN',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'PANGI',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'PASE',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'SANTOL',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'SIEMPREVIVA',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'SUA',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'TALO-ATO',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'TAMANGI',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'TIABAS',
    },
    {
        CITY: 'SAN-DIONISIO',
        BARANGAY: 'TUBLE',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'AMBOYU-AN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'ANDRES BONIFACIO',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'ANTALON',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'BAD-AS',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'BALABAGO',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'BAYUNAN (PANDAY ORO)',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'BOLBOGAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'BONGA',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'BUCAYA',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'BULHO',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'CADLUMAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'CADOLDOLAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'CAMABA-AN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'CAMIA',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'CATA-AN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'CROSSING DAPUYAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'CUBAY',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'CUMARASCAS',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'DACDACANAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'DANAWAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'DOLDOL',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'DONGOC',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'ESCALANTERA',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'GINOT-AN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'GUIBONGAN BAYUNAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'HUNA',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'IGBAJE',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'IGBANGCAL',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'IGBINANGON',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'IGBURI',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'IGCABUTONG',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'IGCADLUM',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'IGCAPHANG',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'IGCARATONG',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'IGCONDAO',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'IGCORES',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'IGDAGMAY',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'IGDOMINGDING',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'IGLILICO',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'IGPAYONG',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'JAWOD',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'LANGCA',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'LANGUANAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'LAWIGAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'LOMBOY',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'LOMBOYAN (SANTA ANA)',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'LOPEZ VITO',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'MABINI NORTE',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'MABINI SUR',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'MANHARA',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'MANINILA',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'MASAGUD',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'MATAMBOG',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'MAYUNOC',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'MONTINOLA',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'NADSADAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'NAGQUIRISAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'NAGSIPIT',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'NEW GUMAWAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'PANATAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'PITOGO',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'PUROK 1 (POB.)',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'PUROK 2 (POB.)',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'PUROK 3 (POB.)',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'PUROK 4 (POB.)',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'PUROK 5 (POB.)',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'QUI-ANAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'ROMA',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'SAN MATEO NORTE',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'SAN MATEO SUR',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'SINOGBUHAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'SIWARAGAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'TALAGUTAC',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'TAPIKAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'TASLAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'TIGLAWA',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'TIOLAS',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'TO-OG',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'TOROCADAN',
    },
    {
        CITY: 'SAN-JOAQUIN',
        BARANGAY: 'ULAY',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'AGUIRRE',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'ALDEGUER',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'ALIBAYOG',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'ANORING',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'APELO',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'APOLOGISTA',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'APOSAGA',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'ARANTE',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'ARDEMIL',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'ASPERA',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'ASWE-PABRIAGA',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'BAGAYGAY',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'BAKABAK',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'BATITAO',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'CASTOR',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'CRESPO',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'DEL CASTILLO',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'DEVERA',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'DOMINGO',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'FERRARIS',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'GILDORE',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'IMPROGO',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'JUANEZA',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'LABIGAN',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'LANCIOLA',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'LATAWAN',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'MALAPAYA',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'MUYCO',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'PADIOS',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'PASIG',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'POBLACION ILAWOD',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'POBLACION ILAYA',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'POBLACION MARKET',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'POSADAS',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'PRECIOSA',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'SALCEDO',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'TADY',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'TENTAY',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'VILLAHERMOSA',
    },
    {
        CITY: 'SARA',
        BARANGAY: 'ZERRUDO',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'ALUPIDIAN',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'ATABAYAN',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BAGUINGIN',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BANGKAL',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BANTUD',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BAROSONG',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BARROC',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BAYUCO',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BINALIUAN MAYOR',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BINALIUAN MENOR',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BITAS',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BUGASONGAN',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'BUYU-AN',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'CANABUAN',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'CANSILAYAN',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'CORDOVA NORTE',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'CORDOVA SUR',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'DAPDAP',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'DORONG-AN',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'GUISIAN',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'ISAUAN',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'ISAWAN',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'ISIAN',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'JAMOG',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'LANAG',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'LINOBAYAN',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'LUBOG',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'NAGBA',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'NAMOCON',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'NAPNAPAN NORTE',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'NAPNAPAN SUR',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'OLO BARROC',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'PARARA NORTE',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'PARARA SUR',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'SERMON',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'SIPITAN',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'SUPA',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'TAN PAEL',
    },
    {
        CITY: 'TIGBAUAN',
        BARANGAY: 'TARO',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'ADGAO',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'AGO',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'AMBARIHON',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'AYUBO',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'BACAN',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'BADIANG',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'BAGUNANAY',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'BALICUA',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'BANTAYANAN',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'BATGA',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'BIKIL',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'BOLOC',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'BONDOC',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'BORONG',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'CADABDAB',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'DAGA-AY',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'DESPOSORIO',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'IGDAMPOG NORTE',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'IGDAMPOG SUR',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'IGPAHO',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'IGTUBLE',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'INGAY',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'ISAUAN',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'JOLASON',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'JONA',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'LA-AG',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'LANAG NORTE',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'LANAG SUR',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'MALE',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'MAYANG',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'MOLINA',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'MORCILLAS',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'NAGBA',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'NAVILLAN',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'PINAMACALAN',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'SIBUCAUAN',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'SINGON',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'TABAT',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'TAGPU-AN',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'TALENTO',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'TENIENTE BENITO',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'TUBUNGAN',
        BARANGAY: 'ZONE III (POB.)',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'BALUD I',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'BALUD II',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'BALUD LILO-AN',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'DAWIS CENTRO',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'DAWIS NORTE',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'DAWIS SUR',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'GINES',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'ILAWOD POBLACION',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'ILAYA POBLACION',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'INAGDANGAN CENTRO',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'INAGDANGAN NORTE',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'INAGDANGAN SUR',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'JALAUD NORTE',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'JALAUD SUR',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'LIBONGCOGON',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'MALUNANG',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'PAJO',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'SAMBAG',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'SIGANGAO',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'TALAUGUIS',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'TALIBONG',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'TUBIGAN',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'ZARRAGA',
        BARANGAY: 'TUBURAN SULBOD',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'ARANAS',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'ARCANGEL',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'CALIZO',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'CORTES',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'FELICIANO',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'FULGENCIO',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'GUANKO',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'MORALES',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'OQUENDO',
    },
    {
        CITY: 'BALETE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'AGBANAWAN',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'BACAN',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'BADIANGAN',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'CERRUDO',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'CUPANG',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'DAGUITAN',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'DAJA NORTE',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'DAJA SUR',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'DINGLE',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'JUMARAP',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'LAPNAG',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'LINABUAN SUR',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'MAMBOG',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'MANGAN',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'MUGUING',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'PAGSANGHAN',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'PALALE',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'POLO',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'POLOCATE',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'SIBALEW',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'SIGCAY',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'TABA-AO',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'TABAYON',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'TINAPUAY',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'TORRALBA',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'UGSOD',
    },
    {
        CITY: 'BANGA',
        BARANGAY: 'VENTURANZA',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'BANAYBANAY',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'BIGA-A',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'BULABUD',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'CABAYUGAN',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'CAPATAGA',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'DANGCALAN',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'KINALANGAY NUEVO',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'KINALANGAY VIEJO',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'LILO-AN',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'MALANDAYON',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'MANHANIP',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'NAVITAS',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'OSMAN',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'SAN DIMAS',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'SIPAC',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'SUGNOD',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'TAMBUAN',
    },
    {
        CITY: 'MALINAO',
        BARANGAY: 'TIGPALAS',
    },
    {
        CITY: 'ALTAVAS',
        BARANGAY: 'CABANGILA',
    },
    {
        CITY: 'ALTAVAS',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'ALTAVAS',
        BARANGAY: 'CATMON',
    },
    {
        CITY: 'ALTAVAS',
        BARANGAY: 'DALIPDIP',
    },
    {
        CITY: 'ALTAVAS',
        BARANGAY: 'GINICTAN',
    },
    {
        CITY: 'ALTAVAS',
        BARANGAY: 'LINAYASAN',
    },
    {
        CITY: 'ALTAVAS',
        BARANGAY: 'LUMAYNAY',
    },
    {
        CITY: 'ALTAVAS',
        BARANGAY: 'LUPO',
    },
    {
        CITY: 'ALTAVAS',
        BARANGAY: 'MAN-UP',
    },
    {
        CITY: 'ALTAVAS',
        BARANGAY: 'ODIONG',
    },
    {
        CITY: 'ALTAVAS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ALTAVAS',
        BARANGAY: 'QUINASAY-AN',
    },
    {
        CITY: 'ALTAVAS',
        BARANGAY: 'TALON',
    },
    {
        CITY: 'ALTAVAS',
        BARANGAY: 'TIBIAO',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'AMBOLONG',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'ANGAS',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'BAY-ANG',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'CAIYANG',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'CAMALIGAN',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'CAMANCI',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'LALAB',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'LUPIT',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'MAGPAG-ONG',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'MAGUBAHAY',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'MAMBUQUIAO',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'MANDONG',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'MAN-UP',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'NAPTI',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'PALAY',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'SONGCOLAN',
    },
    {
        CITY: 'BATAN',
        BARANGAY: 'TABON',
    },
    {
        CITY: 'BURUANGA',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'BURUANGA',
        BARANGAY: 'BAGONGBAYAN',
    },
    {
        CITY: 'BURUANGA',
        BARANGAY: 'BALUSBOS',
    },
    {
        CITY: 'BURUANGA',
        BARANGAY: 'BEL-IS',
    },
    {
        CITY: 'BURUANGA',
        BARANGAY: 'CABUGAN',
    },
    {
        CITY: 'BURUANGA',
        BARANGAY: 'EL PROGRESO',
    },
    {
        CITY: 'BURUANGA',
        BARANGAY: 'HABANA',
    },
    {
        CITY: 'BURUANGA',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'BURUANGA',
        BARANGAY: 'MAYAPAY',
    },
    {
        CITY: 'BURUANGA',
        BARANGAY: 'NAZARETH',
    },
    {
        CITY: 'BURUANGA',
        BARANGAY: 'PANILONGAN',
    },
    {
        CITY: 'BURUANGA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BURUANGA',
        BARANGAY: 'SANTANDER',
    },
    {
        CITY: 'BURUANGA',
        BARANGAY: 'TAG-OSIP',
    },
    {
        CITY: 'BURUANGA',
        BARANGAY: 'TIGUM',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'AGBAGO',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'AGDUGAYAN',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'APARICIO',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'AQUINO',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'ASLUM',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'BATUAN',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'BUGTONGBATO',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'CAPILIJAN',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'COLONGCOLONG',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'LAGUINBANUA',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'MABUSAO',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'MALINDOG',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'MALOCO',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'MINA-A',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'MONLAQUE',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'NAILE',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'NAISUD',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'NALIGUSAN',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'ONDOY',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'POLO',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'REGADOR',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'RIVERA',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'TAGBAYA',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'TUL-ANG',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'UNAT',
    },
    {
        CITY: 'IBAJAY',
        BARANGAY: 'YAWAN',
    },
    {
        CITY: 'KALIBO',
        BARANGAY: 'ANDAGAW',
    },
    {
        CITY: 'KALIBO',
        BARANGAY: 'BACHAW NORTE',
    },
    {
        CITY: 'KALIBO',
        BARANGAY: 'BACHAW SUR',
    },
    {
        CITY: 'KALIBO',
        BARANGAY: 'BRIONES',
    },
    {
        CITY: 'KALIBO',
        BARANGAY: 'BUSWANG NEW',
    },
    {
        CITY: 'KALIBO',
        BARANGAY: 'BUSWANG OLD',
    },
    {
        CITY: 'KALIBO',
        BARANGAY: 'CAANO',
    },
    {
        CITY: 'KALIBO',
        BARANGAY: 'ESTANCIA',
    },
    {
        CITY: 'KALIBO',
        BARANGAY: 'LINABUAN NORTE',
    },
    {
        CITY: 'KALIBO',
        BARANGAY: 'MABILO',
    },
    {
        CITY: 'KALIBO',
        BARANGAY: 'MOBO',
    },
    {
        CITY: 'KALIBO',
        BARANGAY: 'NALOOK',
    },
    {
        CITY: 'KALIBO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KALIBO',
        BARANGAY: 'POOK',
    },
    {
        CITY: 'KALIBO',
        BARANGAY: 'TIGAYON',
    },
    {
        CITY: 'KALIBO',
        BARANGAY: 'TINIGAW',
    },
    {
        CITY: 'LEZO',
        BARANGAY: 'AGCAWILAN',
    },
    {
        CITY: 'LEZO',
        BARANGAY: 'BAGTO',
    },
    {
        CITY: 'LEZO',
        BARANGAY: 'BUGASONGAN',
    },
    {
        CITY: 'LEZO',
        BARANGAY: 'CARUGDOG',
    },
    {
        CITY: 'LEZO',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'LEZO',
        BARANGAY: 'IBAO',
    },
    {
        CITY: 'LEZO',
        BARANGAY: 'MINA',
    },
    {
        CITY: 'LEZO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LEZO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'LEZO',
        BARANGAY: 'SANTA CRUZ BIGAA',
    },
    {
        CITY: 'LEZO',
        BARANGAY: 'SILAKAT-NONOK',
    },
    {
        CITY: 'LEZO',
        BARANGAY: 'TAYHAWAN',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'AGMAILIG',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'ALFONSO XII',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'BATOBATO',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'BONZA',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'CALACABIAN',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'CALAMCAN',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'CAN-AWAN',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'CASIT-AN',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'DALAGSA-AN',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'JANLUD',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'JULITA',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'LUCTOGA',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'MAGUGBA',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'MANIKA',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'OGSIP',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'ORTEGA',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'OYANG',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'PAMPANGO',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'PINONOY',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'RIVERA',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'ROSAL',
    },
    {
        CITY: 'LIBACAO',
        BARANGAY: 'SIBALEW',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'ALAMINOS',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'ALAS-AS',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'BACYANG',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'BALACTASAN',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'CABANGAHAN',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'CABILAWAN',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'CATABANA',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'DIT-ANA',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'GALICIA',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'GUINATU-AN',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'LOGOHON',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'MAMBA',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'MARIA CRISTINA',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'MEDINA',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'MERCEDES',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'NAPNOT',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'PANG-ITAN',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'PANINGAYAN',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'PANIPIASON',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'SINGAY',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'TALANGBAN',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'TALIMAGAO',
    },
    {
        CITY: 'MADALAG',
        BARANGAY: 'TIGBAWAN',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'AGBALOGO',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'AGLUCAY',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'ALIBAGON',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'BAGONG BARRIO',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'CABATANGA',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'CAJILO',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'CALANGCANG',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'CALIMBAJAN',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'CASTILLO',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'CAYANGWAN',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'DUMGA',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'LIBANG',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'MANTIGUIB',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'TIBIAWAN',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'TINA',
    },
    {
        CITY: 'MAKATO',
        BARANGAY: 'TUGAS',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'ARGAO',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'BALABAG',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'BALUSBUS',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'CABULIHAN',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'CATICLAN',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'CUBAY NORTE',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'CUBAY SUR',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'DUMLOG',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'MANOC-MANOC',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'MOTAG',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'NAASUG',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'NABAOY',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'NAPAAN',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'SAN VIRAY',
    },
    {
        CITY: 'MALAY',
        BARANGAY: 'YAPAK',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'ALIMBO-BAYBAY',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'BUENAFORTUNA',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'BUENASUERTE',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'GIBON',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'HABANA',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'LASERNA',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'MAGALLANES',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'MATABANA',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'NAGUSTAN',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'PAWA',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'PINATUAD',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'SOLIDO',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'TAGOROROC',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'TOLEDO',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'UNIDOS',
    },
    {
        CITY: 'NABAS',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'NEW-WASHINGTON',
        BARANGAY: 'CANDELARIA',
    },
    {
        CITY: 'NEW-WASHINGTON',
        BARANGAY: 'CAWAYAN',
    },
    {
        CITY: 'NEW-WASHINGTON',
        BARANGAY: 'DUMAGUIT',
    },
    {
        CITY: 'NEW-WASHINGTON',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'NEW-WASHINGTON',
        BARANGAY: 'GUINBALIWAN',
    },
    {
        CITY: 'NEW-WASHINGTON',
        BARANGAY: 'JALAS',
    },
    {
        CITY: 'NEW-WASHINGTON',
        BARANGAY: 'JUGAS',
    },
    {
        CITY: 'NEW-WASHINGTON',
        BARANGAY: 'LAWA-AN',
    },
    {
        CITY: 'NEW-WASHINGTON',
        BARANGAY: 'MABILO',
    },
    {
        CITY: 'NEW-WASHINGTON',
        BARANGAY: 'MATAPHAO',
    },
    {
        CITY: 'NEW-WASHINGTON',
        BARANGAY: 'OCHANDO',
    },
    {
        CITY: 'NEW-WASHINGTON',
        BARANGAY: 'PINAMUK-AN',
    },
    {
        CITY: 'NEW-WASHINGTON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'NEW-WASHINGTON',
        BARANGAY: 'POLO',
    },
    {
        CITY: 'NEW-WASHINGTON',
        BARANGAY: 'PUIS',
    },
    {
        CITY: 'NEW-WASHINGTON',
        BARANGAY: 'TAMBAK',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'ALBASAN',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'ALIPUTOS',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'BADIO',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'BUBOG',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'BULWANG',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'CAMANCI NORTE',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'CAMANCI SUR',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'DONGON EAST',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'DONGON WEST',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'JOYAO-JOYAO',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'LAGUINBANUA EAST',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'LAGUINBANUA WEST',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'MARIANOS',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'NAVITAS',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'PUSIW',
    },
    {
        CITY: 'NUMANCIA',
        BARANGAY: 'TABANGKA',
    },
    {
        CITY: 'TANGALAN',
        BARANGAY: 'AFGA',
    },
    {
        CITY: 'TANGALAN',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'TANGALAN',
        BARANGAY: 'DAPDAP',
    },
    {
        CITY: 'TANGALAN',
        BARANGAY: 'DUMATAD',
    },
    {
        CITY: 'TANGALAN',
        BARANGAY: 'JAWILI',
    },
    {
        CITY: 'TANGALAN',
        BARANGAY: 'LANIPGA',
    },
    {
        CITY: 'TANGALAN',
        BARANGAY: 'NAPATAG',
    },
    {
        CITY: 'TANGALAN',
        BARANGAY: 'PANAYAKAN',
    },
    {
        CITY: 'TANGALAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TANGALAN',
        BARANGAY: 'PUDIOT',
    },
    {
        CITY: 'TANGALAN',
        BARANGAY: 'TAGAS',
    },
    {
        CITY: 'TANGALAN',
        BARANGAY: 'TAMALAGON',
    },
    {
        CITY: 'TANGALAN',
        BARANGAY: 'TAMOKOE',
    },
    {
        CITY: 'TANGALAN',
        BARANGAY: 'TONDOG',
    },
    {
        CITY: 'TANGALAN',
        BARANGAY: 'VIVO',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'BAYO GRANDE',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'BAYO PEQUENO',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'BUTUAN',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'CASAY',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'CASAY VIEJO',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'IBA',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'IGBARABATUAN',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'IGPALGE',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'IGTUMAROM',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'LISUB A',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'LISUB B',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'MABUYONG',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'MAGDALENA',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'NASULI C',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'NATO',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'SAGUA',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'TAGAYTAY',
    },
    {
        CITY: 'ANINI-Y',
        BARANGAY: 'TALISAYAN',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'BARUSBUS',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'BULANAO',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'CENTRO ESTE (POB.)',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'CENTRO WESTE (POB.)',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'CODIONG',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'CUBAY',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'IGCAGAY',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'INYAWAN',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'LINDERO',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'MARAMIG',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'PAJO',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'PANANGKILON',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'PAZ',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'PUCIO',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'TABOC',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'TINIGBAS',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'TININDUGAN',
    },
    {
        CITY: 'LIBERTAD',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'ATABAY',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BADIANG',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BARIRI',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'BUGAROT (CATUNGAN-BUGAROT)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CANSADAN (CANSADAN-TUBUDAN)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'DUROG',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'FUNDA-DALIPE',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'IGBONGLO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'INABASAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MADRANGCA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MAGCALON',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MALAIBA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MAYBATO NORTE',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MAYBATO SUR',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MOJON',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'PANTAO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN ANGEL',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SUPA',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'AGRICULA',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'ANINGALAN',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'ATABAY',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'BALADJAY',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'BANBANAN',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'BARANGBANG',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'BAWANG',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'BUGO',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'BULAN-BULAN',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'CABIAWAN',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'CABUNGA-AN',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'CADOLONAN',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'CARAWISAN I',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'CARAWISAN II',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'CARMELO I',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'CARMELO II',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'GENERAL FULLON',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'GENERAL LUNA',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'IGUIRINDON',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'INSUBUAN',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'LA UNION',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'LAPAK',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'LUMPATAN',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'MAGDALENA',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'MARAGUBDUB',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'NAGBANGI I (AMATONG)',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'NAGBANGI II',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'NASULI',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'ORQUIA (IGCATUMBAL)',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'OSORIO I',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'OSORIO II',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'PANPANAN I',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'PANPANAN II',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'POBLACION (CALAG-ITAN)',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'RAMON MAGSAYSAY',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'SINUNDOLAN',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'SUMARAY',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'TRINIDAD',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'TUBUDAN',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'VILVAR',
    },
    {
        CITY: 'SAN-REMIGIO',
        BARANGAY: 'WALKER',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'BAGHARI',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'BAHUYAN',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'BERI',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'BIGA-A',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'BINANGBANG',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'BINANGBANG CENTRO',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'BINANU-AN',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'CADIAO',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'CALAPADAN',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'CAPOYUAN',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'CUBAY',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'EMBRANGGA-AN',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'ESPARAR',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'GUA',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'IDAO',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'IGPALGE',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'IGTUNARUM',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'INTEGASAN',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'JINALINAN',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'LANAS',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'LANGCAON (EVELIO JAVIER)',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'LISUB',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'LOMBUYAN',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'MABLAD',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'MAGTULIS',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'MARIGNE',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'MAYABAY',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'MAYOS',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'NALUSDAN',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'NARIRONG',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'PALMA',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'SOLIGAO',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'TABONGTABONG',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'TIG-ALARAN',
    },
    {
        CITY: 'BARBAZA',
        BARANGAY: 'YAPO',
    },
    {
        CITY: 'BELISON',
        BARANGAY: 'BOROCBOROC',
    },
    {
        CITY: 'BELISON',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'BELISON',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'BELISON',
        BARANGAY: 'DELIMA',
    },
    {
        CITY: 'BELISON',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'BELISON',
        BARANGAY: 'MARADIONA',
    },
    {
        CITY: 'BELISON',
        BARANGAY: 'MOJON',
    },
    {
        CITY: 'BELISON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BELISON',
        BARANGAY: 'ROMBANG',
    },
    {
        CITY: 'BELISON',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'BELISON',
        BARANGAY: 'SINAJA',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'ANILAWAN',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'ARANGOTE',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'BAGTASON',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'CAMANGAHAN',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'CENTRO ILAWOD (POB.)',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'CENTRO ILAYA (POB.)',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'CENTRO POJO (POB.)',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'CUBAY NORTH',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'CUBAY SOUTH',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'GUIJA',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'IGBALANGAO',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'IGSORO',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'ILAURES',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'JINALINAN',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'LACAYON',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'MARAY',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'PALIWAN',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'PANGALCAGAN',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'SABANG EAST',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'SABANG WEST',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'TAGUDTUD NORTH',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'TAGUDTUD SOUTH',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'TICA',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'TONO-AN',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'YAPU',
    },
    {
        CITY: 'BUGASONG',
        BARANGAY: 'ZARAGOZA',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'BACONG',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'BANAGO',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'DAWIS',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'DIONELA',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'HARIGUE',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'HININGA-AN',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'IMBA',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'MASANAG',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'SALAMENTO',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'SEMIRARA',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'SIBATO',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'SIBAY',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'SIBOLO',
    },
    {
        CITY: 'CALUYA',
        BARANGAY: 'TINOGBOC',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'ALOJIPAN',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'BALAC-BALAC',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'BATBATAN ISLAND',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'BATONAN NORTE',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'BATONAN SUR',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'BITA',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'BITADTON NORTE',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'BITADTON SUR',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'BUHI',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'CAMANCIJAN',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'CARIDAD',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'CARIT-AN',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'CENTRO NORTE (POB.)',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'CENTRO POBLACION',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'CENTRO SUR (POB.)',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'CONDES',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'FE',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'FLORES',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'JALANDONI',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'JANLAGASI',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'LAMPUTONG',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'LIPATA',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'MAGSAYSAY (BALUA)',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'MALACANANG',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'MALALISON ISLAND',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'MANIGUIN',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'NABA',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'OSORIO',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'PANINGAYAN',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'SALDE',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'SAN GREGORIO',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'SAN PASCUAL',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'SIMBOLA',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'TIGBOBOLO',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'TINABUSAN',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'TOMAO',
    },
    {
        CITY: 'CULASI',
        BARANGAY: 'VALDERAMA',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'APDO',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'ASLUMAN',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'BANAWON',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'BIA-AN',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'BONGBONGAN III',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'BONGBONGAN I-II',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'BOTBOT',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'BUDBUDAN',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'BUHANG',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'CALACJA I',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'CALACJA II',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'CALALA',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'CANTULAN',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'CARIDAD',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'CAROMANGAY',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'CASALNGAN',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'DANGCALAN',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'FABRICA',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'FUNDA',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'GENERAL FULLON (TINA)',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'GOV. EVELIO B. JAVIER (LANAG)',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'GUINTAS',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'IGBICAL',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'IGBUCAGAY',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'INABASAN',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'INGWAN-BATANGAN',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'LINABAN',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'MALANDOG',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'MAPATAG',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'MASANAG',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'NALIHAWAN',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'PAMANDAYAN (BOTBOT)',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'PASU-JUNGAO',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'PIAPE I',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'PIAPE II',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'PIAPE III',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'PILI 1',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'PILI 1 2 3',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'POBLACION 3',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'POBLACION 4',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'POBLACION 5',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'PU-AO',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'SULOC',
    },
    {
        CITY: 'HAMTIC',
        BARANGAY: 'VILLAVERT-JIMENEZ',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'BAGONGBAYAN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'BANBAN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'BONGBONGAN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'CABARIWAN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'CADAJUG',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'CANITUAN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'CAPNAYAN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'CASIT-AN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'GUIAMON',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'GUINBANGA-AN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'GUISIJAN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'IGTADIAO',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'INTAO',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'JAGUIKICAN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'JINALINAN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'LACTUDAN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'LATAZON',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'LAUA-AN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'LIBERATO',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'LINDERO',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'LIYA-LIYA',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'LOON',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'LUGTA',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'LUPA-AN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'MAGYAPO',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'MARIA',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'MAUNO',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'MAYBUNGA',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'NECESITO (PANIATAN)',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'OLOC',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'OMLOT',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'PANDANAN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'PANINGAYAN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'PASCUALA',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'POBLACION (CENTRO)',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'TIBACAN',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'TIGUNHAO',
    },
    {
        CITY: 'LAUA-AN',
        BARANGAY: 'VIRGINIA',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'ARACAY',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'BADIANGAN',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'BOTBOT',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'BUANG',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'CANDARI',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'CARMEN',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'CENTRO NORTE (POB.)',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'CENTRO SUR (POB.)',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'DIONELA',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'DUMROG',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'DUYONG',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'FRAGANTE',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'GUIA',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'IDIACACAN',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'JINALINAN',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'LUHOD-BAYANG',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'MAADIOS',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'MAG-ABA',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'NAPUID',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'NAURING',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'PATRIA',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'PERFECTA',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'SAN JOAQUIN',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'TINGIB',
    },
    {
        CITY: 'PANDAN',
        BARANGAY: 'ZALDIVAR',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'ALVANIZ',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'AMPARO',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'APGAHAN',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'AURELIANA',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'BADIANGAN',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'BERNALDO A. JULAGTING (BITAS)',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'CARIT-AN',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'CUYAPIAO',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'GELLA',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'IGBARAWAN',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'IGBOBON',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'IGBURI',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'LA RIOJA',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'MABASA',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'MACARINA',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'MAGARANG',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'PADANG',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'PANDANAN',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'PATLABAWON',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'SALAGUIAWAN',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'SAMALAGUE',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'TAMAYOC',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'TIGBALOGO',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'TOBIAS FORNIER',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'VILLA CRESPO',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'VILLA CRUZ',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'VILLA ELIO',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'VILLA FLORES',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'VILLA LAUA-AN',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'VILLA SAL',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'VILLA SALOMON',
    },
    {
        CITY: 'PATNONGON',
        BARANGAY: 'VISTA ALEGRE',
    },
    {
        CITY: 'SEBASTE',
        BARANGAY: 'ABIERA',
    },
    {
        CITY: 'SEBASTE',
        BARANGAY: 'AGUILA',
    },
    {
        CITY: 'SEBASTE',
        BARANGAY: 'ALEGRE',
    },
    {
        CITY: 'SEBASTE',
        BARANGAY: 'ARAS-ASAN',
    },
    {
        CITY: 'SEBASTE',
        BARANGAY: 'BACALAN',
    },
    {
        CITY: 'SEBASTE',
        BARANGAY: 'CALLAN',
    },
    {
        CITY: 'SEBASTE',
        BARANGAY: 'IDIO',
    },
    {
        CITY: 'SEBASTE',
        BARANGAY: 'NAUHON',
    },
    {
        CITY: 'SEBASTE',
        BARANGAY: 'P. JAVIER',
    },
    {
        CITY: 'SEBASTE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'ALANGAN',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'BARI',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'BIGA-A',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'BONGBONGAN I',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'BONGBONGAN II',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'BONGSOD',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'BONTOL',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'BUGNAY',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'BULALACAO',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'CABANBANAN',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'CABARIUAN',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'CABLADAN',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'CADOLDOLAN',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'CALOG',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'CALO-OY',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'CATMON',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'CATUNGAN I',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'CATUNGAN II',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'CATUNGAN III',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'CATUNGAN IV',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'CUBAY-NAPULTAN',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'CUBAY-SERMON',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'DISTRICT I (POB.)',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'DISTRICT II (POB.)',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'DISTRICT III (POB.)',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'DISTRICT IV (POB.)',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'EGANA',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'ESPERANZA I',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'ESPERANZA II',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'ESPERANZA III',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'IGCOCOC',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'IGDAGMAY',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'IGDALAQUIT',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'IGLANOT',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'IGPANOLONG',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'IGPARAS',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'IGSUMING',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'ILABAS',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'IMPARAYAN',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'INABASAN',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'INDAG-AN',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'INITAN',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'INSARAYAN',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'LACARON',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'LAGDO',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'LAMBAYAGAN',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'LUYANG',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'MAASIN',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'MILLAMENA',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'MOJON',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'NAGDAYAO',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'NAZARETH',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'ODIONG',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'OLAGA',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'PANGPANG',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'PANLAGANGAN',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'PANTAO',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'PASONG',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'PIS-ANAN',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'ROMBANG',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'SIDO',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'SOLONG',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'TABONGTABONG',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'TIGBALUA I',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'TIGBALUA II',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'TIG-OHOT',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'TORDESILLAS',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'TULATULA',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'VALENTIN GRASPARIL (BAD-AS)',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'VILLAFONT',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'VILLAHERMOSA',
    },
    {
        CITY: 'SIBALOM',
        BARANGAY: 'VILLAR',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'ALEGRE',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'AMAR',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'BANDOJA (LUPA-AN)',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'CASTILLO',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'ESPARAGOZA',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'IMPORTANTE',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'MALABOR',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'MARTINEZ',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'NATIVIDAD',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'PITAC',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'SALAZAR',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'SAN FRANCISCO NORTE',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'SAN FRANCISCO SUR',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'SANTA JUSTA',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'TIGBABOY',
    },
    {
        CITY: 'TIBIAO',
        BARANGAY: 'TUNO',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'ABACA',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'ARAS-ASAN',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'AROBO',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'ATABAY',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'ATIOTES',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'BALLOSCAS',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'BALUD',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'BARASANAN A',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'BARASANAN B',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'BARASANAN C',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'BARIRI',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'CAMANDAGAN',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'CATO-OGAN',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'DANAWAN',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'DICLUM',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'GAMAD (IGDAMACIO)',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'IGBALOGO',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'IGBANGCAL-A',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'IGBANGCAL-B',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'IGBANGCAL-C',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'IGCABUAD',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'IGCADAC',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'IGCADO',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'IGCALAWAGAN',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'IGCAPUYAS',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'IGCASICAD (SAN PEDRO)',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'IGDALAGUIT',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'IGDANLOG',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'IGDURAROG',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'IGTUGAS',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'LAWIGAN',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'LINDERO',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'MANALING (CATA-AN)',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'MASAYO',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'NAGSUBUAN',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'NASULI-A (SAN RAMON)',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'OPSAN (SAN JOSE)',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'PACIENCIA',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'PORTILLO',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'SALAMAGUE (SANTA MARIA)',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'TACBUYAN',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'TENE',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'VILLAFLOR',
    },
    {
        CITY: 'TOBIAS-FORNIER',
        BARANGAY: 'YSULAT',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'ALON',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'BAKIANG',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'BINANOGAN',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'BOROCBOROC',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'BUGNAY',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'BULUANGAN I',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'BULUANGAN II',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'BUNSOD',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'BUSOG',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'CANANGHAN',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'CANIPAYAN',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'CANSILAYAN',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'CULYAT',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'IGLINAB',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'IGMASANDIG',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'LUBLUB',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'MANLACBO',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'PANDANAN',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'TAKAS (POB.)',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'TIGMAMALE',
    },
    {
        CITY: 'VALDERRAMA',
        BARANGAY: 'UBOS (POB.)',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BALOGO',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BINAOBAWAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'BLASCO',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'CASANAYAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'CAYUS',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'DAYHAGAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'DULANGAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'MONTEFLOR',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'NATIVIDAD',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'OLALO',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN BLAS',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN ESTEBAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN SILVESTRE',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SINAMONGAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'TABUN-ACAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'YATING',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'AGBANOG',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'AGDALIPE',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'AMELIGAN',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'BAILAN',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'BANATE',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'BANTIGUE',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'BINUNTUCAN',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'BUENAVISTA GIBONG',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'BUENAVISTA RIZAL',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'CAMBARUS',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'CANROMA',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'DON SALVADOR BENEDICTO (CARMEN)',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'GABUC (CAUGIAT)',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'GENERAL MALVAR',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'GOMEZ',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'GUBA',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'HIPONA',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'ILAWOD (POB.)',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'ILAYA (POB.)',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'INTUNGCAN',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'JOLONGAJOG',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'LANTANGAN',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'LINAMPONGAN',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'MALAG-IT',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'MANAPAO',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'SOLO',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'SUBLANGON',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'TABUC',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'TACAS',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'YATINGAN',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'ARANGUEL',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'BADIANGON',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'BAYUYAN',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'CABUGCABUG',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'CARMENCITA',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'CUBAY',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'CULILANG',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'GOCE',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'HANGLID',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'IBACA',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'MADULANO',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'MANOLING',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'MARITA',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'PANTALAN CABUGCABUG',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'PINAMIHAGAN',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'POBLACION (ELIZALDE)',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'PONDOL',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'QUIAJO',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'SANGKAL',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'PRESIDENT-ROXAS',
        BARANGAY: 'VIZCAYA',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'AGCABUGAO',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'AGDAHON',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'AGNAGA',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'ANGUB',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'BALINGASAG',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'BITO-ON ILAWOD',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'BITO-ON ILAYA',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'BUN-OD',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'CARATAYA',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'LUNAYAN',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'MAHABANG SAPA',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'MAHUNODHUNOD',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'MAINDANG',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'MAINIT',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'MALAGAB-I',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'NAGBA',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'POBLACION ILAWOD',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'POBLACION ILAYA',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'POBLACION TAKAS',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'PUTI-AN',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'CUARTERO',
        BARANGAY: 'SINABSABAN',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'AGANAN',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'AGTAMBI',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'AGTANGUAY',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'BALUCUAN',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'BITA',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'CENTRO',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'DAPLAS',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'DUYOC',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'ILAS SUR',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'LACARON',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'MALONOY',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'MANHOY',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'MAPULANG BATO',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'MATAGNOP',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'NASUNOGAN',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'POBLACION ILAWOD',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'POBLACION ILAYA',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'QUINABCABAN',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'QUINAYUYA',
    },
    {
        CITY: 'DAO',
        BARANGAY: 'SAN AGUSTIN (ILAS NORTE)',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'CONSOLACION',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'DURAN',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'SAN MARTIN',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'SANTA CARMEN',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'SANTA TERESA',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'SANTO ANGEL',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'DUMALAG',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'AGBATUAN',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'AGLALANA',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'AGLANOT',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'AGSIRAB',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'ALIPASIAWAN',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'ASTORGA',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'BAYOG',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'BUNGSUAN',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'CALAPAWAN',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'CODINGLE',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'CUBI',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'DACUTON',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'DANGULA',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'GIBATO',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'GUINOTOS',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'JAMBAD',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'JANGUSLOB',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'LAWAAN',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'MALONOY',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'NAGSULANG',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'ONGOL ILAWOD',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'ONGOL ILAYA',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'POBLACION ILAWOD',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'POBLACION ILAYA',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'SAGRADA FAMILIA',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'SALCEDO',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'SIBARIWAN',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'TAMULALOD',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'TASLAN',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'TINA',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'TINAYTAYAN',
    },
    {
        CITY: 'DUMARAO',
        BARANGAY: 'TRACIANO',
    },
    {
        CITY: 'IVISAN',
        BARANGAY: 'AGMALOBO',
    },
    {
        CITY: 'IVISAN',
        BARANGAY: 'AGUSTIN NAVARRA',
    },
    {
        CITY: 'IVISAN',
        BARANGAY: 'BALARING',
    },
    {
        CITY: 'IVISAN',
        BARANGAY: 'BASIAO',
    },
    {
        CITY: 'IVISAN',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'IVISAN',
        BARANGAY: 'CUDIAN',
    },
    {
        CITY: 'IVISAN',
        BARANGAY: 'ILAYA-IVISAN',
    },
    {
        CITY: 'IVISAN',
        BARANGAY: 'MALOCLOC NORTE',
    },
    {
        CITY: 'IVISAN',
        BARANGAY: 'MALOCLOC SUR',
    },
    {
        CITY: 'IVISAN',
        BARANGAY: 'MATNOG',
    },
    {
        CITY: 'IVISAN',
        BARANGAY: 'MIANAY',
    },
    {
        CITY: 'IVISAN',
        BARANGAY: 'ONDOY',
    },
    {
        CITY: 'IVISAN',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'IVISAN',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'IVISAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'AGAMBULONG',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'AGBUN-OD',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'AGCAGAY',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'AGLIBACAO',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'AGLOLOWAY',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'BAYEBAYE',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'CARIDAD',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'FE',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'GANZON',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'GUINTAS',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'IGANG',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'JAENA NORTE',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'JAENA SUR',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'JAGNAYA',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'LAPAZ',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'LINAMBASAN',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'LUCERO',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'MAANTOL',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'MASGRAU',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'MILAN',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'MOLET',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'PANGABAT',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'PANGABUAN',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'PASOL-O',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'JAMINDAN',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'AGLIMOCON',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'ALASAGING',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'ALAYUNAN',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'BALIGHOT',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'BATABAT',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'BONGBONGAN',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'CABUNGAHAN',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'CANAPIAN',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'CARATAYA',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'DULUAN',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'EAST VILLAFLORES',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'FERNANDEZ',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'GUINBI-ALAN',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'INDAYAGAN',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'JEBACA',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'MAALAN',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'MANAYUPIT',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'NEW GUIA',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'OLD GUIA',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'PALAGUIAN',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'PARALLAN',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'PINA',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'POBLACION ILAWOD',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'POBLACION ILAYA',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'POBLACION TABUC',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'QUEVEDO (NGALAN)',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'QUINABONGLAN',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'QUINAT-UYAN',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'SALGAN',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'TAPULANG',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'MA-AYON',
        BARANGAY: 'WEST VILLAFLORES',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'ATIPLO',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'BALAT-AN',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'BALIT',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'BATIANO',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'BATING',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'BATO BATO',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'BAYE',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'BERGANTE',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'BULA',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'BUNGA',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'BUNGSI',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'BURIAS',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'CAIDQUID',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'CALA-AGUS',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'LIBO-O',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'MANIBAD',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'MARALAG',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'NAJUS-AN',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'PANGPANG NORTE',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'PANGPANG SUR',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'PINAY',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'POBLACION PROPER',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'POBLACION TABUC',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'SINONDOJAN',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'TUGAS',
    },
    {
        CITY: 'MAMBUSAO',
        BARANGAY: 'TUMALALUD',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'AGBALO',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'AGBANBAN',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'AGOJO',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'ANHAWON',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'BAGO CHIQUITO',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'BAGO GRANDE',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'BAHIT',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'BANTIQUE',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'BINANGIG',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'BINANTUAN',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'BONGA',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'BUNTOD',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'BUTACAL',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'CABUGAO ESTE',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'CABUGAO OESTE',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'CALAPAWAN',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'CALITAN',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'CANDUAL',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'DAGA',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'ILAMNAY',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'JAMUL-AWON',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'LANIPGA',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'LAT-ASAN',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'LIBON',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'LINATERAN',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'LOMBOY',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'LUS-ONAN',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'MAGUBILAN',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'NAVITAS',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'PAWA',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'POBLACION ILAWOD',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'POBLACION ILAYA',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'POBLACION TABUC',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'TALASA',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'TANZA NORTE',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'TANZA SUR',
    },
    {
        CITY: 'PANAY',
        BARANGAY: 'TICO',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'AGBABADIANG',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'AGKILO',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'AGLOWAY',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'AMBILAY',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'BAHIT',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'BALATUCAN',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'BANGA-AN',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'CABANGAHAN',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'CADIO',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'CALA-AN',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'CAPAGAO',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'CONCIENCIA',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'ENSENAGAN',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'INTAMPILAN',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'PASUGUE',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'POBLACION ILAWOD',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'POBLACION ILAYA',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'QUIOS',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'SALOCON',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'TABUC NORTE',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'TABUC SUR',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'TIMPAS',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'TINCUPON',
    },
    {
        CITY: 'PANITAN',
        BARANGAY: 'TINIGBAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'ADLAWAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BAGO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BALIJUAGAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BANICA',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BARRA',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'BOLO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'CAGAY',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'CULAJAO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'CULASI',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'DAYAO',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'DINGINAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'DUMOLOG',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'GABU-AN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'INZO ARNALDO VILLAGE (CADIMAHAN)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'JUMAGUICJIC',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'LANOT',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'LAWA-AN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'LIONG',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'LOCTUGAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'LONOY',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MILIBILI',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'MONGPONG',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'OLOTAYAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'POBLACION I (BARANGAY I)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'POBLACION II (BARANGAY II)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'POBLACION III (BARANGAY III)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'POBLACION IV (BARANGAY IV)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'POBLACION IX (BARANGAY IX)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'POBLACION V (BARANGAY V)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'POBLACION VI (BARANGAY VI)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'POBLACION VII (BARANGAY VII)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'POBLACION VIII (BARANGAY VIII)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'POBLACION X (BARANGAY X)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'POBLACION XI (BARANGAY XI)',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'PUNTA COGON',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'PUNTA TABUC',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'SIBAGUAN',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'TALON',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'TANQUE',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'TANZA',
    },
    {
        CITY: 'ROXAS',
        BARANGAY: 'TIZA',
    },
    {
        CITY: 'SAPI-AN',
        BARANGAY: 'AGSILAB',
    },
    {
        CITY: 'SAPI-AN',
        BARANGAY: 'AGTATACAY NORTE',
    },
    {
        CITY: 'SAPI-AN',
        BARANGAY: 'AGTATACAY SUR',
    },
    {
        CITY: 'SAPI-AN',
        BARANGAY: 'BILAO',
    },
    {
        CITY: 'SAPI-AN',
        BARANGAY: 'DAMAYAN',
    },
    {
        CITY: 'SAPI-AN',
        BARANGAY: 'DAPDAPAN',
    },
    {
        CITY: 'SAPI-AN',
        BARANGAY: 'LONOY',
    },
    {
        CITY: 'SAPI-AN',
        BARANGAY: 'MAJANLUD',
    },
    {
        CITY: 'SAPI-AN',
        BARANGAY: 'MANINANG',
    },
    {
        CITY: 'SAPI-AN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'ACBO',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'AMAGA',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'BALUCUAN',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'BANGONBANGON',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'CAPUYHAN',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'COGON',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'DAYHAGON',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'GUINTAS',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'MALAPAD COGON',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'MANGOSO',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'MANSACUL',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'MATANGCONG',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'MATINABUS',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'MIANAY',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'OYONG',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'PAGBUNITAN',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'PARIAN',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'PINAMALATICAN',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'SIGMA',
        BARANGAY: 'TAWOG',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'ABANGAY',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'ACUNA',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'AGCOCOC',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'AGLINAB',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'AGLUPACAN',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'AGPALALI',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'APERO',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'ARTUZ',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'BAG-ONG BARRIO',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'BATO-BATO',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'BURI',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'CAMBURANAN',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'CANDELARIA',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'CARIDA',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'CRISTINA',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'DA-AN BANWA',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'DA-AN NORTE',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'DA-AN SUR',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'GARCIA',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'GEBIO-AN',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'HILWAN',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'INITAN',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'LAGDUNGAN',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'LAHUG',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'MALIAO',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'MALITBOG',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'MINAN',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'NAYAWAN',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'RIZAL NORTE',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'RIZAL SUR',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'ROOSEVELT',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'SALONG',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'SAN JULIAN',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'SAN MIGUEL ILAWOD',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'SAN MIGUEL ILAYA',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'SANTA PETRONILA',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'SENONOD',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'SIYA',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'SWITCH',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'TABON',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'TACAYAN',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'TAFT',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'TAGANGHIN',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'TASLAN',
    },
    {
        CITY: 'TAPAZ',
        BARANGAY: 'WRIGHT',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'AGSANAYAN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'AVILA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BACJAO (CALUMINGAN)',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'BANBAN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'CANSILAYAN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'DAGSA-AN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'DARAGAN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'EAST VALENCIA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'GETULIO',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MCLAIN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MONTPILLER',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'NAVALAS',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'NAZARET',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'NEW POBLACION (CALINGAO)',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'OLD POBLACION',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'PINA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SAWANG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SUPANG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'TACAY',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'TAMINLA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'TANAG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'TASTASAN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'TINADTARAN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'UMILIG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'ZALDIVAR',
    },
    {
        CITY: 'JORDAN',
        BARANGAY: 'ALAGUISOC',
    },
    {
        CITY: 'JORDAN',
        BARANGAY: 'BALCON MARAVILLA',
    },
    {
        CITY: 'JORDAN',
        BARANGAY: 'BALCON MELLIZA',
    },
    {
        CITY: 'JORDAN',
        BARANGAY: 'BUGNAY',
    },
    {
        CITY: 'JORDAN',
        BARANGAY: 'BULUANGAN',
    },
    {
        CITY: 'JORDAN',
        BARANGAY: 'ESPINOSA',
    },
    {
        CITY: 'JORDAN',
        BARANGAY: 'HOSKYN',
    },
    {
        CITY: 'JORDAN',
        BARANGAY: 'LAWI',
    },
    {
        CITY: 'JORDAN',
        BARANGAY: 'MOROBUAN',
    },
    {
        CITY: 'JORDAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'JORDAN',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'JORDAN',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'JORDAN',
        BARANGAY: 'SANTA TERESA',
    },
    {
        CITY: 'JORDAN',
        BARANGAY: 'SINAPSAPAN',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'CABALAGNAN',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'CALAYA',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'CANHAWAN',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'CONCORDIA SUR',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'GUIWANON',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'IGANG',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'IGDARAPDAP',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'LANIPE',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'LUCMAYAN',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'MAGAMAY',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'NAPANDONG',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'ORACON SUR',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'PANDARAONAN',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'PANOBOLON',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'NUEVA-VALENCIA',
        BARANGAY: 'TANDO',
    },
    {
        CITY: 'SAN-LORENZO',
        BARANGAY: 'AGUILAR',
    },
    {
        CITY: 'SAN-LORENZO',
        BARANGAY: 'CABANO',
    },
    {
        CITY: 'SAN-LORENZO',
        BARANGAY: 'CABUNGAHAN',
    },
    {
        CITY: 'SAN-LORENZO',
        BARANGAY: 'CONSTANCIA',
    },
    {
        CITY: 'SAN-LORENZO',
        BARANGAY: 'GABAN',
    },
    {
        CITY: 'SAN-LORENZO',
        BARANGAY: 'IGCAWAYAN',
    },
    {
        CITY: 'SAN-LORENZO',
        BARANGAY: 'M. CHAVEZ',
    },
    {
        CITY: 'SAN-LORENZO',
        BARANGAY: 'SAN ENRIQUE (LEBAS)',
    },
    {
        CITY: 'SAN-LORENZO',
        BARANGAY: 'SAPAL',
    },
    {
        CITY: 'SAN-LORENZO',
        BARANGAY: 'SEBARIO',
    },
    {
        CITY: 'SAN-LORENZO',
        BARANGAY: 'SUCLARAN',
    },
    {
        CITY: 'SAN-LORENZO',
        BARANGAY: 'TAMBORONG',
    },
    {
        CITY: 'SIBUNAG',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'SIBUNAG',
        BARANGAY: 'AYANGAN',
    },
    {
        CITY: 'SIBUNAG',
        BARANGAY: 'BUBOG',
    },
    {
        CITY: 'SIBUNAG',
        BARANGAY: 'CONCORDIA',
    },
    {
        CITY: 'SIBUNAG',
        BARANGAY: 'CONCORDIA NORTE',
    },
    {
        CITY: 'SIBUNAG',
        BARANGAY: 'DASAL',
    },
    {
        CITY: 'SIBUNAG',
        BARANGAY: 'INAMPOLOGAN',
    },
    {
        CITY: 'SIBUNAG',
        BARANGAY: 'MAABAY',
    },
    {
        CITY: 'SIBUNAG',
        BARANGAY: 'MILLAN',
    },
    {
        CITY: 'SIBUNAG',
        BARANGAY: 'ORACON',
    },
    {
        CITY: 'SIBUNAG',
        BARANGAY: 'ORACON NORTE',
    },
    {
        CITY: 'SIBUNAG',
        BARANGAY: 'RAVINA',
    },
    {
        CITY: 'SIBUNAG',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'SIBUNAG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SIBUNAG',
        BARANGAY: 'SEBASTE',
    },
    {
        CITY: 'SIBUNAG',
        BARANGAY: 'TANGLAD',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'ALANGILAN',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'ALIJIS',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BANAGO',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 10 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 11 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 12 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 13 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 14 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 15 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 16 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 17 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 18 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 19 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 20 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 21 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 22 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 23 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 24 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 25 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 26 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 27 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 28 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 29 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 30 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 31 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 32 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 33 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 34 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 35 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 36 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 37 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 38 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 39 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 40 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 41 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'BATA',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'CABUG',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'ESTEFANIA',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'FELISA',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'GRANADA',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'HANDUMANAN',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'MANDALAGAN',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'MANSILINGAN',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'MONTEVISTA',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'PAHANOCOY',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'PUNTA TAYTAY',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'SINGCANG-AIRPORT',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'SUM-AG',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'TACULING',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'TANGUB',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'VILLAMONTE',
    },
    {
        CITY: 'BACOLOD',
        BARANGAY: 'VISTA ALEGRE',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'ABUANAN',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'ALIANZA',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'ATIPULUAN',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'BACONG-MONTILLA',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'BAGROY',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'BALINGASAG',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'BINUBUHAN',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'BUSAY',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'CALUMANGAN',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'CARIDAD',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'DULAO',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'ILIJAN',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'JORGE L. ARANETA (MA-AO CENTRAL)',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'LAG-ASAN',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'MA-AO BARRIO',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'MAILUM',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'MALINGIN',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'NAPOLES',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'PACOL',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'SAGASA',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'SAMPINIT',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'TABUNAN',
    },
    {
        CITY: 'BAGO',
        BARANGAY: 'TALOC',
    },
    {
        CITY: 'BINALBAGAN',
        BARANGAY: 'AMONTAY',
    },
    {
        CITY: 'BINALBAGAN',
        BARANGAY: 'BAGROY',
    },
    {
        CITY: 'BINALBAGAN',
        BARANGAY: 'BI-AO',
    },
    {
        CITY: 'BINALBAGAN',
        BARANGAY: 'CANMOROS (POB.)',
    },
    {
        CITY: 'BINALBAGAN',
        BARANGAY: 'ENCLARO',
    },
    {
        CITY: 'BINALBAGAN',
        BARANGAY: 'MARINA (POB.)',
    },
    {
        CITY: 'BINALBAGAN',
        BARANGAY: 'PAGLAUM (POB.)',
    },
    {
        CITY: 'BINALBAGAN',
        BARANGAY: 'PAYAO',
    },
    {
        CITY: 'BINALBAGAN',
        BARANGAY: 'PROGRESO (POB.)',
    },
    {
        CITY: 'BINALBAGAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BINALBAGAN',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'BINALBAGAN',
        BARANGAY: 'SAN PEDRO (POB.)',
    },
    {
        CITY: 'BINALBAGAN',
        BARANGAY: 'SAN TEODORO (POB.)',
    },
    {
        CITY: 'BINALBAGAN',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'BINALBAGAN',
        BARANGAY: 'SANTO ROSARIO (POB.)',
    },
    {
        CITY: 'BINALBAGAN',
        BARANGAY: 'SANTOL',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'ANDRES BONIFACIO',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'BANQUEROHAN',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'BARANGAY 1 POB. (ZONE 1)',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'BARANGAY 2 POB. (ZONE 2)',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'BARANGAY 3 POB. (ZONE 3)',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'BARANGAY 4 POB. (ZONE 4)',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'BARANGAY 5 POB. (ZONE 5)',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'BARANGAY 6 POB. (ZONE 6)',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'CABAHUG',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'CADIZ VIEJO',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'CADUHA-AN',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'CELESTINO VILLACIN',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'DAGA',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'JERUSALEM',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'SICABA',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'TIGLAWIGAN',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'TINAMPA-AN',
    },
    {
        CITY: 'CADIZ',
        BARANGAY: 'V. F. GUSTILO',
    },
    {
        CITY: 'CANDONI',
        BARANGAY: 'AGBOY',
    },
    {
        CITY: 'CANDONI',
        BARANGAY: 'BANGA',
    },
    {
        CITY: 'CANDONI',
        BARANGAY: 'CABIA-AN',
    },
    {
        CITY: 'CANDONI',
        BARANGAY: 'CANINGAY',
    },
    {
        CITY: 'CANDONI',
        BARANGAY: 'GATUSLAO',
    },
    {
        CITY: 'CANDONI',
        BARANGAY: 'HABA',
    },
    {
        CITY: 'CANDONI',
        BARANGAY: 'PAYAUAN',
    },
    {
        CITY: 'CANDONI',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'CANDONI',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'ABACA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'BACLAO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'BASAK',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'BULATA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CALILING',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CAMALANDA-AN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'CAMINDANGAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'ELIHAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'GUILJUNGAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'INAYAWAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'ISIO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'LINAON',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'LUMBIA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MAMBUGSAY',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MAN-ULING',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MASALING',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'MOLOBOLO',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'SURA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'TALACDAN',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'TAMBAD',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'TILING',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'TOMINA',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'TUYOM',
    },
    {
        CITY: 'CAUAYAN',
        BARANGAY: 'YAO-YAO',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'ALACAYGAN',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'ALICANTE',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'BATEA',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'CANLUSONG',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'CONSING',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'CUDANGDANG',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'DAMGO',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'GAHIT',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'LATASAN',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'MADALAG',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'MANTA-ANGAN',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'NANCA',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'PASIL',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'POBLACION I (BARANGAY 1)',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'POBLACION II (BARANGAY 2)',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'POBLACION III (BARANGAY 3)',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'TABIGUE',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'TANZA',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'TOMONGTONG',
    },
    {
        CITY: 'ENRIQUE-B.-MAGALONA',
        BARANGAY: 'TUBURAN',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'ALIMANGO',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'BALINTAWAK (POB.)',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'BINAGUIOHAN',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'CERVANTES',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'DIAN-AY',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'HACIENDA FE',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'JAPITAN',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'JONOBJONOB',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'LANGUB',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'MAGSAYSAY (BINABONGOL)',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'MALASIBOG',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'OLD POBLACION',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'PAITAN',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'PINAPUGASAN',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'TAMLANG',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'UDTONGAN',
    },
    {
        CITY: 'ESCALANTE',
        BARANGAY: 'WASHINGTON',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'AGUISAN',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'CABADIANGAN',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'CABANBANAN',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'CARABALAN',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'CARADIO-AN',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'LIBACAO',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'MAHALANG',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'MAMBAGATON',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'NABALI-AN',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'SARA-ET',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'SU-AY',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'TALABAN',
    },
    {
        CITY: 'HIMAMAYLAN',
        BARANGAY: 'TO-OY',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'ANAHAW',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'ARANDA',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'BAGA-AS',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'CALAPI',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'CAMALOBALO',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'CAMBA-OG',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'CAMBUGSA',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'CANDUMARAO',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'GARGATO',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'HIMAYA',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'MIRANDA',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'NANUNGA',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'NARAUIS',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'PALAYOG',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'PATICUI',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'PILAR',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'QUIWI',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'TAGDA',
    },
    {
        CITY: 'HINIGARAN',
        BARANGAY: 'TUGUIS',
    },
    {
        CITY: 'HINOBA-AN',
        BARANGAY: 'ALIM',
    },
    {
        CITY: 'HINOBA-AN',
        BARANGAY: 'ASIA',
    },
    {
        CITY: 'HINOBA-AN',
        BARANGAY: 'BACUYANGAN',
    },
    {
        CITY: 'HINOBA-AN',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'HINOBA-AN',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'HINOBA-AN',
        BARANGAY: 'BULWANGAN',
    },
    {
        CITY: 'HINOBA-AN',
        BARANGAY: 'CULIPAPA',
    },
    {
        CITY: 'HINOBA-AN',
        BARANGAY: 'DAMUTAN',
    },
    {
        CITY: 'HINOBA-AN',
        BARANGAY: 'DAUG',
    },
    {
        CITY: 'HINOBA-AN',
        BARANGAY: 'PO-OK',
    },
    {
        CITY: 'HINOBA-AN',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'HINOBA-AN',
        BARANGAY: 'SANGKE',
    },
    {
        CITY: 'HINOBA-AN',
        BARANGAY: 'TALACAGAY',
    },
    {
        CITY: 'ILOG',
        BARANGAY: 'ANDULAUAN',
    },
    {
        CITY: 'ILOG',
        BARANGAY: 'BALICOTOC',
    },
    {
        CITY: 'ILOG',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'ILOG',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'ILOG',
        BARANGAY: 'BOCANA',
    },
    {
        CITY: 'ILOG',
        BARANGAY: 'CALUBANG',
    },
    {
        CITY: 'ILOG',
        BARANGAY: 'CANLAMAY',
    },
    {
        CITY: 'ILOG',
        BARANGAY: 'CONSUELO',
    },
    {
        CITY: 'ILOG',
        BARANGAY: 'DANCALAN',
    },
    {
        CITY: 'ILOG',
        BARANGAY: 'DELICIOSO',
    },
    {
        CITY: 'ILOG',
        BARANGAY: 'GALICIA',
    },
    {
        CITY: 'ILOG',
        BARANGAY: 'MANALAD',
    },
    {
        CITY: 'ILOG',
        BARANGAY: 'PINGGOT',
    },
    {
        CITY: 'ILOG',
        BARANGAY: 'TABU',
    },
    {
        CITY: 'ILOG',
        BARANGAY: 'VISTA ALEGRE',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'AMIN',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BANOGBANOG',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BULAD',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'BUNGAHIN',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'CABCAB',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'CAMANGCAMANG',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'CAMP CLARK',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'CANSALONGON',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'GUINTUBHAN',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'LIMALIMA',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'MAKILIGNIT',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'MANSABLAY',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'MAYTUBIG',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'PANAQUIAO',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'RIVERSIDE',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'RUMIRANG',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'SEBUCAWAN',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'SIKATUNA',
    },
    {
        CITY: 'ISABELA',
        BARANGAY: 'TINONGAN',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'BANTAYAN',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'BINICUIL',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'CAMANSI',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'CAMINGAWAN',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'CAMUGAO',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'CAROL-AN',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'DAAN BANUA',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'HILAMONAN',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'INAPOY',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'LINAO',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'LOCOTAN',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'MAGBALLO',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'ORINGAO',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'ORONG',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'PINAGUINPINAN',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'SALONG',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'TABUGON',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'TAGOC',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'TAGUKON',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'TALUBANGI',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'TAMPALON',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'TAN-AWAN',
    },
    {
        CITY: 'KABANKALAN',
        BARANGAY: 'TAPI',
    },
    {
        CITY: 'LA-CARLOTA',
        BARANGAY: 'ARA-AL',
    },
    {
        CITY: 'LA-CARLOTA',
        BARANGAY: 'AYUNGON',
    },
    {
        CITY: 'LA-CARLOTA',
        BARANGAY: 'BALABAG',
    },
    {
        CITY: 'LA-CARLOTA',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'LA-CARLOTA',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'LA-CARLOTA',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'LA-CARLOTA',
        BARANGAY: 'BATUAN',
    },
    {
        CITY: 'LA-CARLOTA',
        BARANGAY: 'CUBAY',
    },
    {
        CITY: 'LA-CARLOTA',
        BARANGAY: 'HAGUIMIT',
    },
    {
        CITY: 'LA-CARLOTA',
        BARANGAY: 'LA GRANJA',
    },
    {
        CITY: 'LA-CARLOTA',
        BARANGAY: 'NAGASI',
    },
    {
        CITY: 'LA-CARLOTA',
        BARANGAY: 'ROBERTO S. BENEDICTO (CONSUELO)',
    },
    {
        CITY: 'LA-CARLOTA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'LA-CARLOTA',
        BARANGAY: 'YUBO',
    },
    {
        CITY: 'LA-CASTELLANA',
        BARANGAY: 'BIAKNABATO',
    },
    {
        CITY: 'LA-CASTELLANA',
        BARANGAY: 'CABACUNGAN',
    },
    {
        CITY: 'LA-CASTELLANA',
        BARANGAY: 'CABAGNAAN',
    },
    {
        CITY: 'LA-CASTELLANA',
        BARANGAY: 'CAMANDAG',
    },
    {
        CITY: 'LA-CASTELLANA',
        BARANGAY: 'LALAGSAN',
    },
    {
        CITY: 'LA-CASTELLANA',
        BARANGAY: 'MANGHANOY',
    },
    {
        CITY: 'LA-CASTELLANA',
        BARANGAY: 'MANSALANAO',
    },
    {
        CITY: 'LA-CASTELLANA',
        BARANGAY: 'MASULOG',
    },
    {
        CITY: 'LA-CASTELLANA',
        BARANGAY: 'NATO',
    },
    {
        CITY: 'LA-CASTELLANA',
        BARANGAY: 'PUSO',
    },
    {
        CITY: 'LA-CASTELLANA',
        BARANGAY: 'ROBLES (POB.)',
    },
    {
        CITY: 'LA-CASTELLANA',
        BARANGAY: 'SAG-ANG',
    },
    {
        CITY: 'LA-CASTELLANA',
        BARANGAY: 'TALAPTAP',
    },
    {
        CITY: 'MANAPLA',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'MANAPLA',
        BARANGAY: 'BARANGAY I-A (POB.)',
    },
    {
        CITY: 'MANAPLA',
        BARANGAY: 'BARANGAY I-B (POB.)',
    },
    {
        CITY: 'MANAPLA',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'MANAPLA',
        BARANGAY: 'BARANGAY II-A (POB.)',
    },
    {
        CITY: 'MANAPLA',
        BARANGAY: 'CHAMBERY',
    },
    {
        CITY: 'MANAPLA',
        BARANGAY: 'PUNTA MESA',
    },
    {
        CITY: 'MANAPLA',
        BARANGAY: 'PUNTA SALONG',
    },
    {
        CITY: 'MANAPLA',
        BARANGAY: 'PURISIMA',
    },
    {
        CITY: 'MANAPLA',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'MANAPLA',
        BARANGAY: 'SANTA TERESA',
    },
    {
        CITY: 'MANAPLA',
        BARANGAY: 'TORTOSA',
    },
    {
        CITY: 'MOISES-PADILLA',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'MOISES-PADILLA',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'MOISES-PADILLA',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'MOISES-PADILLA',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'MOISES-PADILLA',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'MOISES-PADILLA',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'MOISES-PADILLA',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'MOISES-PADILLA',
        BARANGAY: 'CROSSING MAGALLON',
    },
    {
        CITY: 'MOISES-PADILLA',
        BARANGAY: 'GUINPANA-AN',
    },
    {
        CITY: 'MOISES-PADILLA',
        BARANGAY: 'INOLINGAN',
    },
    {
        CITY: 'MOISES-PADILLA',
        BARANGAY: 'MACAGAHAY',
    },
    {
        CITY: 'MOISES-PADILLA',
        BARANGAY: 'MAGALLON CADRE',
    },
    {
        CITY: 'MOISES-PADILLA',
        BARANGAY: 'MONTILLA',
    },
    {
        CITY: 'MOISES-PADILLA',
        BARANGAY: 'ODIONG',
    },
    {
        CITY: 'MOISES-PADILLA',
        BARANGAY: 'QUINTIN REMO',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'ABO-ABO',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'AMAYCO',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'BLUMENTRITT',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'CALIBAN',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'CANLANDOG',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'CANSILAYAN',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'DAMSITE',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'IGLAU-AN',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'LOPEZ JAENA',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'MINOYAN',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'PANDANON',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'TALOTOG',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'ZONE III (POB.)',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'ZONE IV (POB.)',
    },
    {
        CITY: 'MURCIA',
        BARANGAY: 'ZONE V (POB.)',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'AGPANGI',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'ANI-E',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'BAGACAY',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'BANTAYANON',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'CABUNGAHAN',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'CALAMPISAWAN',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'CAMBAYOBO',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'CASTELLANO',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'CRUZ',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'DOLIS',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'HILUB-ANG',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'HINAB-ONGAN',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'ILAYA',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'LAGA-AN',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'LALONG',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'LEMERY',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'LIPAT-ON',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'LO-OK (POB.)',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'MA-ASLOB',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'MACASILAO',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'MAHILUM',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'MALANOG',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'MALATAS',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'MARCELO',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'MENCHACA',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'MINAPASUK',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'MINA-UTOK',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'PAGHUMAYAN',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'PANTAO',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'PATUN-AN',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'PINOCUTAN',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'REFUGIO',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'SAN BENITO',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'SUBA (POB.)',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'TELIM',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'TIGBAO',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'TIGBON',
    },
    {
        CITY: 'CALATRAVA',
        BARANGAY: 'WINASWASAN',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'BUENAVISTA GIBONG',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'BUENAVISTA RIZAL',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'CAMBARUS',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'CANROMA',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'DON SALVADOR BENEDICTO (CARMEN)',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'GENERAL MALVAR',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'GOMEZ',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'JOLONGAJOG',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'LANTANGAN',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'LINAMPONGAN',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'M. H. DEL PILAR',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'MALAG-IT',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'MANAPAO',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'MIRANDA',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'RECREO',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'SOLO',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'SUBLANGON',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'TABUC',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'TACAS',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'YATINGAN',
    },
    {
        CITY: 'PONTEVEDRA',
        BARANGAY: 'ZAMORA',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BAGONBON',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BARANGAY VI (POB.)',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BULUANGAN',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'CODCOD',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'ERMITA',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'NATABAN',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PALAMPAS',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PROSPERIDAD',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PUNAO',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'POBLACION ILAWOD',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'POBLACION ILAYA',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'QUINOLPAN',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'RUMAGAYRAY',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'SIBUCAO',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'TABAO BAYBAY',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'TABAO RIZAL',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'TAMBUNAC',
    },
    {
        CITY: 'SAN-ENRIQUE',
        BARANGAY: 'TIBSOC',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'BUBOG',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'CABATANGAN',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'DOS HERMANAS',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'EFIGENIO LIZARES',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'KATILINGBAN',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'MATAB-ANG',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 1 (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 10 (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 11 (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 12 (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 12-A (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 14 (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 14-A (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 14-B (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 15 (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 16 (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 2 (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 3 (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 4 (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 4-A (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 5 (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 6 (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 7 (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 8 (POB.)',
    },
    {
        CITY: 'TALISAY',
        BARANGAY: 'ZONE 9 (POB.)',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'BARANGAY ZONE 1 (POB.)',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'BARANGAY ZONE 1-A (POB.)',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'BARANGAY ZONE 2 (POB.)',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'BARANGAY ZONE 3 (POB.)',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'BARANGAY ZONE 4 (POB.)',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'BARANGAY ZONE 4-A (POB.)',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'BARANGAY ZONE 5 (POB.)',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'BARANGAY ZONE 6 (POB.)',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'BARANGAY ZONE 7 (POB.)',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'CANJUSA',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'CROSSING PULUPANDAN',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'CULO',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'PAG-AYON',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'PALAKA NORTE',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'PALAKA SUR',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'PATIC',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'TAPONG',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'UBAY',
    },
    {
        CITY: 'PULUPANDAN',
        BARANGAY: 'UTOD',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'ANDRES BONIFACIO',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'BAVIERA',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'BULANON',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'CAMPO HIMOGA-AN',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'CAMPO SANTIAGO',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'COLONIA DIVINA',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'FABRICA',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'GENERAL LUNA',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'HIMOGA-AN BAYBAY',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'LOPEZ JAENA',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'MAKILING',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'MALUBON',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'MOLOCABOC',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'OLD SAGAY',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'PARAISO',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'POBLACION I (BARANGAY 1)',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'POBLACION II (BARANGAY 2)',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'PUEY',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'RAFAELA BARRERA',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'TABA-AO',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'TADLONG',
    },
    {
        CITY: 'SAGAY',
        BARANGAY: 'VITO',
    },
    {
        CITY: 'SALVADOR-BENEDICTO',
        BARANGAY: 'BAGO (LALUNG)',
    },
    {
        CITY: 'SALVADOR-BENEDICTO',
        BARANGAY: 'BAGONG SILANG (MARCELO)',
    },
    {
        CITY: 'SALVADOR-BENEDICTO',
        BARANGAY: 'BUNGA',
    },
    {
        CITY: 'SALVADOR-BENEDICTO',
        BARANGAY: 'IGMAYA-AN',
    },
    {
        CITY: 'SALVADOR-BENEDICTO',
        BARANGAY: 'KUMALISKIS',
    },
    {
        CITY: 'SALVADOR-BENEDICTO',
        BARANGAY: 'PANDANON',
    },
    {
        CITY: 'SALVADOR-BENEDICTO',
        BARANGAY: 'PINOWAYAN (PROSPERIDAD)',
    },
    {
        CITY: 'SILAY',
        BARANGAY: 'BAGTIC',
    },
    {
        CITY: 'SILAY',
        BARANGAY: 'BALARING',
    },
    {
        CITY: 'SILAY',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'SILAY',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'SILAY',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'SILAY',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'SILAY',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'SILAY',
        BARANGAY: 'BARANGAY VI POB. (HAWAIIAN)',
    },
    {
        CITY: 'SILAY',
        BARANGAY: 'EUSTAQUIO LOPEZ',
    },
    {
        CITY: 'SILAY',
        BARANGAY: 'GUIMBALA-ON',
    },
    {
        CITY: 'SILAY',
        BARANGAY: 'GUINHALARAN',
    },
    {
        CITY: 'SILAY',
        BARANGAY: 'KAPITAN RAMON',
    },
    {
        CITY: 'SILAY',
        BARANGAY: 'LANTAD',
    },
    {
        CITY: 'SILAY',
        BARANGAY: 'MAMBULAC',
    },
    {
        CITY: 'SILAY',
        BARANGAY: 'PATAG',
    },
    {
        CITY: 'SILAY',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'CABADIANGAN',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'CAMINDANGAN',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'CANTURAY',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'CARTAGENA',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'CAYHAGAN',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'GIL MONTILLA',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'MAMBAROTO',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'MANLUCAHOC',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'MARICALUM',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'NABULAO',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'NAUHANG',
    },
    {
        CITY: 'SIPALAY',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'TOBOSO',
        BARANGAY: 'BANDILA',
    },
    {
        CITY: 'TOBOSO',
        BARANGAY: 'BUG-ANG',
    },
    {
        CITY: 'TOBOSO',
        BARANGAY: 'GENERAL LUNA',
    },
    {
        CITY: 'TOBOSO',
        BARANGAY: 'MAGTICOL',
    },
    {
        CITY: 'TOBOSO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TOBOSO',
        BARANGAY: 'SALAMANCA',
    },
    {
        CITY: 'TOBOSO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TOBOSO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'TOBOSO',
        BARANGAY: 'TABUN-AC',
    },
    {
        CITY: 'VALLADOLID',
        BARANGAY: 'ALIJIS',
    },
    {
        CITY: 'VALLADOLID',
        BARANGAY: 'AYUNGON',
    },
    {
        CITY: 'VALLADOLID',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'VALLADOLID',
        BARANGAY: 'BATUAN',
    },
    {
        CITY: 'VALLADOLID',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'VALLADOLID',
        BARANGAY: 'CENTRAL TABAO',
    },
    {
        CITY: 'VALLADOLID',
        BARANGAY: 'DOLDOL',
    },
    {
        CITY: 'VALLADOLID',
        BARANGAY: 'GUINTORILAN',
    },
    {
        CITY: 'VALLADOLID',
        BARANGAY: 'LACARON',
    },
    {
        CITY: 'VALLADOLID',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'VALLADOLID',
        BARANGAY: 'PACOL',
    },
    {
        CITY: 'VALLADOLID',
        BARANGAY: 'PALAKA',
    },
    {
        CITY: 'VALLADOLID',
        BARANGAY: 'PALOMA',
    },
    {
        CITY: 'VALLADOLID',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'VALLADOLID',
        BARANGAY: 'SAGUA BANUA',
    },
    {
        CITY: 'VALLADOLID',
        BARANGAY: 'TABAO PROPER',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY IX (DAAN BANWA)',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY VI (POB.)',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY VI-A',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY VII (POB.)',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY VIII (POB.)',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY X (ESTADO)',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY XI (GAWAHON)',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY XII',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY XIII',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY XIV',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY XIX',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY XIX-A',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY XV',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY XV-A',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY XVI',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY XVI-A',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY XVII',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY XVIII',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY XVIII-A',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY XX',
    },
    {
        CITY: 'VICTORIAS',
        BARANGAY: 'BARANGAY XXI',
    }
];
